
import { AllBlStatusInfo, AllContainerStatusInfo, BlStatusInfo, BookingContainerResponse, ConfirmOrAssignSoResponse, ContainerDetailsModel, ContainerDetailsResponse, ContainerDispatchedToPlantResponse, ContainerStatusInfo, DraftReceivedResponse, FillSealInfoResponse, SoContainerStatusUpdate, InitiateDispatchResponse, ContainerResponse, EtdUpdateRequest, BillNoUpdateRequest, ContaierRegisterRequest, LoadingReportModel, AllLoadingReportResponse, ShipmentDetailsDto, ShippmentDetailsResponse, FilenameDto, ContainerReportResponse, ContainerReportModel, ContainerReportPlantsData, ContainerBarChartDto, ContainerBarChartResponseModel, TopFiveDestinationDto, Containertrnd, ContainerStatusRequest, GrossMassResponseModel, componentRequest } from '@gtpl/shared-models/logistics';

import { Injectable } from '@nestjs/common';
import { ContainerRepository } from './repository/container.repository';
import { SaleOrderService, saleOrder } from '@gtpl/shared-services/sale-management';
import { StockService } from '@gtpl/shared-services/procurement';
import { ContainerLoadingStatus, MessageRequest, ContainerStatusEnum, ErrorResponse, BlStatusEnum, SoStatusEnum, SaleOrderStatusEnum, UomEnum, JobTypesEnum, EmployeeRolesEnum, MessageParameters, GlobalVariableValues, LoadingSheetSaleOrderReq, PostShipmentCreateDto, FgStatusEnum } from '@gtpl/shared-models/common-models';
import { BookContainerDto } from './dto/book-container.dto';
import { ContainerAdapter } from './dto/container.adapter';
import { DispatchedToPlant } from './dto/container-dispatched-to-plant.dto';
import { ConfirmOrAssignSoData } from './dto/confirm-or-assign-so.dto';
import { ContainerLogRepository } from './repository/container-log.repository';
import { ContainerDTO } from './dto/container.dto';
import { DraftReceived } from './dto/draft-received.dto';
import { containerLogDto } from './dto/container-log.dto';
import { ContainerLogAdapter } from './dto/container-log.adapter';
import { PlantInvoiceDetailsRequest, SaleOrderDropDownDto, saleOrderItemIdRequest, UnitsOfWeightInput } from '@gtpl/shared-models/sale-management';
import { ContainerSoIdRequest } from './dto/container-soId.request';
import { ContainerRegisterRequest } from './dto/container-register.request';
import { DestinationService } from '@gtpl/shared-services/masters';
import { AuthorisedRequest, ContainerIdRequest, SaleOrderIdRequestLc } from './dto/container-id.request';
import { DocumentsListService } from '@gtpl/shared-services/logistics'
import { Repository, getManager } from 'typeorm';
import appSettings from 'apps/services/config';
import { UnitRequest } from './dto/unit.id.request';
import { SaleOrderIdRequest } from '@gtpl/shared-models/procurement-management';
import { FGStockService } from '@gtpl/shared-services/warehouse-management';
import { SoIdRequest } from '@gtpl/shared-models/warehouse-management';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { ContainerYearRequest } from './dto/container-year-request';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import moment = require("moment");
import { Cron } from '@nestjs/schedule';
import { BroadCastMessageRequest, WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import { whatsApp } from '../../../../whatsapp';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management'
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { LoadingSheetReqDto } from './loading-sheet-req-dto';
import { Container } from './container.entity';
import { LoadingSheetEntity } from './dto/loading-sheet-entity';
import { InjectRepository } from '@nestjs/typeorm';
import { FreightAfterShipmentDto } from './dto/freight-after-shipment.dto';

import { ExpensesLogisticsEntity } from './dto/expenses-logistics-entity';
import { ExpensesLogisticsRepo } from './repository/expenses-logistics-repo';
import { SaleOrderIdRequest as saleOrderIdRequest } from 'libs/shared-models/logistics/src/lib/container-register/container.request';
import { ExpensesLogisticsUpdateEntity } from './dto/expenses-logstics-update-entity';
import { BlContainerDischargeReq } from './dto/bl-container-discharege-dto';
import { SaleOrderIdRequest as saleOrderBLIdrequest } from 'libs/shared-models/logistics/src/lib/container-register/container.request';
import { PostShipmentDetailsEntity } from './dto/post-shipment-details-entity';
import { PostShipmentDetailsDto } from './dto/post-shipment-details-dto';
import { PostShipmentRepo } from './repository/post-shipment-repo';
import { ExpensesLogisticsDto } from './dto/expenses-logistics-dto';
import { DailySheetData } from './dto/daily-sheet-date.req';



// import { Container } from './container.entity';
// import { ErrorResponse } from '@gtpl/shared-models/common-models';
// // import (ContainerResponseModel) from '@gtpl/shared-models/logistics-management';
// import { ContainerDTO } from './dto/container.dto';

@Injectable()
export class ContainerService {
    constructor(private repository: ContainerRepository,
        private containerLogRepo: ContainerLogRepository,
        private soService: SaleOrderService,
        private stockService: StockService,
        private fGStockService: FGStockService,
        private adapter: ContainerAdapter,
        private logAdapter: ContainerLogAdapter,
        private destinationService: DestinationService,
        private documentsListService: DocumentsListService,
        private wtsAppBroadCatService: WhatsappBroadCastService,
        private wpService: WhatsAppNotificationService,
        @InjectRepository(Container)
        private soLoadingSheetRepo: Repository<Container>,
        private postShipmentDetailsRepo: PostShipmentRepo,        
        private expensesLogisticsRepo: ExpensesLogisticsRepo,
        @InjectRepository(ExpensesLogisticsUpdateEntity)
        private readonly expensesLogisticsUpdateRepo: Repository<ExpensesLogisticsUpdateEntity>,
    ) { }
    // containerRepo: any;
    // containerAdapter: any;
    // itemsAdapter: any;


    // async CreateContainer(containerData: ContainerDTO, isUpdate?: boolean): Promise<ContainerResponseModel> {

    //     const containerEntity = this.containerAdapter.convertDtoToEntity(containerData, isUpdate);
    //     const createResponse = await this.containerRepo.save(containerEntity);

    //     const conItems: Container[] = [];
    //     for (const containerItems of containerData.containerItems) {
    //         const itemsEntity = this.itemsAdapter.convertDtoToEntity(conItems, createResponse.containerId);
    //         const createContainerData = await this.containerRepo.save(itemsEntity);
    //         console.log(createContainerData);
    //     }

    //     console.log(containerEntity);
    //     // save entity
    //     console.log(createResponse);
    //     if (createResponse) {
    //         return new 
    //         ContainerResponseModel(true, 1111, 'Created Successfully', 'Created Successfully');
    //     } else {
    //         throw new ErrorResponse(9999, 'Failed To Create')
    //     }


    // }



    async getAllContainerStatusInfo(): Promise<AllContainerStatusInfo> {
        try {

            const containerDetails = this.repository.createQueryBuilder('Container')
            const soTrackInfo = await this.soService.getSoTrackInfo();
            const containerInfo = await containerDetails.getMany();
            if (soTrackInfo.status || containerInfo.length) {
                let containersInfo: ContainerStatusInfo[] = [];
             
                for (const container of containerInfo) {
                   console.log(containerInfo,"!!!!!!!!!!!!!!!!!")
                    let fillSealImages: FilenameDto[] = [];

                    const documentDetails = await this.documentsListService.getDocumentsDetailsForSoId({ saleOrderId: container.saleOrderId });
                    for (const item of documentDetails.data) {
                        const data = new FilenameDto(item.fileName);
                        fillSealImages.push(data);
                    }

                    const SaleOrderItemDetails = await this.soService.getSaleOrderDetailsById({ saleOrderId: container.saleOrderId });
                    let grossWeight = false;
                    for (const item of SaleOrderItemDetails.data.itemData) {
                        if (item.grossWeight > 0) {
                            grossWeight = true;
                        }
                        else {
                            grossWeight = false;
                            break;
                        }
                    }
                    // get sale order details for sale order id
                    const soReq: saleOrder = {
                        saleOrderId: container.saleOrderId
                    }
                    // const saleOrderDetails = await this.soService.getSaleOrderDetailsForId(soReq);
                    const saleOrderDetailsInfo = await this.soService.getSaleOrderInformationById(soReq);

                    console.log('saleOrderDetailsInfo2' + saleOrderDetailsInfo.data.saleOrder + "***" + saleOrderDetailsInfo.data.finalDestination);
                    const containerData = new ContainerStatusInfo(container.containerNumber, container.containerStatus, { saleOrderId: container.saleOrderId, saleOrderNumber: saleOrderDetailsInfo.data.saleOrder }, container.loadingStatus, container.createdUser, container.containerId, container.updatedUser, (saleOrderDetailsInfo) ? saleOrderDetailsInfo.data.saleOrder : '', container.referenceNumber, container.scac, saleOrderDetailsInfo.data.poNo, saleOrderDetailsInfo.data.buyerPoNo, saleOrderDetailsInfo.data.customer, saleOrderDetailsInfo.data.etd, saleOrderDetailsInfo.data.endCustomer, saleOrderDetailsInfo.data.finalDestination, grossWeight, SaleOrderItemDetails.data.unit, container.unitId, fillSealImages, saleOrderDetailsInfo.data.isInvoiced, saleOrderDetailsInfo.data.brand, container.lineSeal, container.vehicleNumber, container.driverName, container.vesselName, container.shippingBillNo, container.transporter, container.vesselNumber, container.vesselSchedule, container.qcReport, container.buyerInspectionReport, container.vesselScheduleApproval, container.temperature, container.scrollNo, container.portCode);
                    containerData.modeOfExport = container.modeOfExport

                    containersInfo.push(containerData);
                }

                if (soTrackInfo.status) {
                    // containersInfo.push(soTrackInfo.data)
                    containersInfo = [...containersInfo, ...soTrackInfo.data]
                }

                return new AllContainerStatusInfo(true, 1111, 'Container Status Info Found Successfully', containersInfo);
            } else {
                throw new ErrorResponse(9999, 'No Data Found')
            }
        } catch (err) {
            return err;
        }

    }
    async getAllContainerStatus(req: UnitRequest): Promise<AllContainerStatusInfo> {
        const manager = getManager();
        //GROUP_CONCAT(doc.file_path) AS filePath 
        let query = `SELECT cn.check_list_status as checkListStatus,cn.shippment_details_status as shippmentDetailsStatus,cn.container_number AS containerNo,  st.container_status AS containerStatus,so.sale_order_id AS saleOrderId,
        so.sale_order_no AS saleOrderNumber,cn.loading_status AS loadingStatus,cn.created_user AS createdUser,
        cn.container_id AS containerId,cn.updated_user AS updatedUser,inv.po_number AS poNo,cn.reference_number AS referenceNumber,
        cn.scac AS scac,cn.vessel_schedule AS vesselSchedule ,cn.vessel_number AS vesselNumber,cn.transporter ,cn.cha ,
         inv.buyer_po_number AS buyerPoNo,c.client_name AS customer, inv.act_edl_date AS etd,ec.end_customer_name AS endCustomer,
         d.destination_name AS destination,IF(si.gross_weight_per_kg > 0, true, false) AS grossWeight,u.unit_code_id AS plantId,
         u.plant_code AS plant, so.is_invoiced AS isInvoiced, co.country_name as country,null as filePath,
         SUM(si.cases) as poQty, SUM(si.reported_cases) as fgQty,si.sale_order_id as saleorderid,production_status AS productionStatus,
         inspection_status AS inspectionStatus,ROUND((SUM(si.reported_cases)/SUM(si.cases))*100) AS percent,
         MAX(si.gross_weight_per_kg)AS grossweightPerKg ,cn.qc_report as qcReport ,cn.buyer_inspection_report as buyerInspectionReport,
         cn.vessel_schedule_approval as vesselScheduleApproval , cn.temperature ,cn.port_code as portCode ,
         cn.examination_date as examinationDate ,cn.stuffing_start_time as stuffingStartTime,
         stuffing_completion_time as stuffingCompletionTime,cn.time_taken_for_stuffing as timeTakenForStuffing ,
         authorised_by as authorisedById ,ed.employee_name as authorisedBy ,si.master_brand_id AS masterBrandId ,
         cn.shipping_bill_no as shippingBillNo,cn.shipping_bill_date as shipping_bill_date , cn.branch_code as branchCode, cn.vessel_name as vesselName,
        cn.eta , cn.bl_no as blNo, cn.temp_indicator_no1 as tempIndicatorNo1, cn.temp_indicator_no2 as tempIndicatorNo2 ,  cn.temp_indicator_no3 as tempIndicatorNo3, 
        mb.brand_name AS brandName, cn.shipping_liner as shippingLiner, cn.temperature_degree as temperaturee,ci.invoice_number as invoiceNumber,cn.mode_of_export as modeOfExport,GROUP_CONCAT(DISTINCT(si.marks_and_no)) AS marksAndNo,uc.company,u.company_id,uc.plant_code as plantCode,inv.factoryId,inv.destination as destinationId,ci.financial_year AS finacialYear
        FROM ` + appSettings.sales_db + `.sale_order so 
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=so.sale_order_id 
        LEFT JOIN ` + appSettings.sales_db + `.sale_order_items si ON si.sale_order_id=so.sale_order_id 
        LEFT JOIN ` + appSettings.masters_db + `.customers c ON c.cust_id=inv.customer_id
        LEFT JOIN ` + appSettings.masters_db + `.end_customers ec ON ec.end_customer_id=inv.end_customer_id 
        LEFT JOIN ` + appSettings.masters_db + `.destination d ON d.destination_id=inv.destination
        LEFT JOIN ` + appSettings.logistics_db + `.container cn ON inv.sale_order_id = cn.sale_order_id
        LEFT JOIN ` + appSettings.logistics_db + `.documents_list doc ON cn.sale_order_id = doc.sale_order_id 
        LEFT JOIN ` + appSettings.masters_db + `.countries co ON co.country_id = inv.country_id
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=inv.processing_unit
         LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id=inv.factoryId
        LEFT JOIN ` + appSettings.sales_db + `.sale_order_track st ON st.sale_order_id=inv.sale_order_id 
        LEFT JOIN ` + appSettings.sales_db + `.so_inspection sin ON sin.sale_order_id=so.sale_order_id 
        LEFT JOIN ` + appSettings.masters_db + `.employee_details ed ON ed.employee_id = cn.authorised_by
        LEFT JOIN ` + appSettings.masters_db + `.master_brands mb ON mb.master_brand_id =si.master_brand_id
        left join ` + appSettings.sales_db + `.customer_invoice ci on ci.sale_order_id = so.sale_order_id and ci.is_active =1
         where inv.job_type!='${JobTypesEnum.SUB_JOB}' and so.status != '${SaleOrderStatusEnum.CANCELLED}' and st.fg_status = '${FgStatusEnum.CLOSE}' and st.container_status='${req.containerStatus}'`;
        // console.log(([
        //     EmployeeRolesEnum.ADMIN,
        //     EmployeeRolesEnum.HO_PACKAGING_MANAGER
        // ].indexOf(req.role)));
        // console.log(req.unitId);
        // if ((([
        //     EmployeeRolesEnum.ADMIN,
        //     EmployeeRolesEnum.HO_PACKAGING_MANAGER
        // ].indexOf(req.role)) === -1)) {
        //     query += ` and inv.processing_unit= ${req.unitId}`;
        // }
        if(req.unitId){
            query += ` and inv.processing_unit = ${req.unitId}`}
            if (req. financialYear != undefined) {
                query += ` and ci.financial_year = '${req. financialYear}'`;
            }
      if (req.fromDate != undefined) {
        query +=  ' and inv.act_edl_date between "' + req.fromDate + '" and "' + req.toDate + '"';
              }

if(req.companyId){
    query += ` and inv.factoryId = ${req.companyId}`}
    if(req.destinationId){
        query += ` and inv.destination = ${req.destinationId}`}
        query += ` group by so.sale_order_id`
        query += ` order by ci.invoice_number`
        
        const queryResult = await manager.query(query);

        const documentFilePathsResponse = await this.getDocumentsFilePaths();
        const documentFilePaths = documentFilePathsResponse.data;

        const filePathMap = documentFilePaths.reduce((acc, doc) => {
            if (!acc[doc.sale_order_id]) {
                acc[doc.sale_order_id] = [];
            }
            acc[doc.sale_order_id].push(doc.file_path); // Push multiple file paths for the same saleOrderId
            return acc;
        }, {});
    
        // const filePathMap = documentFilePaths.reduce((acc, doc) => {
        //     acc[doc.sale_order_id] = doc.file_path;//push single file path for same saleorderId
        //     return acc;
        // }, {});
    
        queryResult.forEach(item => {
            item.filePath = filePathMap[item.saleOrderId] || []; 
        });

        return new AllContainerStatusInfo(true, 1111, 'Container Status Info Found Successfully', queryResult);
    }

    async getDocumentsFilePaths():Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query =`SELECT co.container_id,co.sale_order_id,dl.file_path,dl.file_name FROM ` + appSettings.logistics_db + `.container co
LEFT JOIN ` + appSettings.logistics_db + `.documents_list dl ON dl.sale_order_id=co.sale_order_id`    
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Files retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
    
        }
        }

async checkListInfo(req:saleOrderIdRequest):Promise<CommonResponse>{
    try{
        const manager = getManager()
        let query55 =`select c. qc_report as qcReport, c.buyer_inspection_report as buyerInspectionReport, c.vessel_schedule_approval as vesselScheduleApproval, c.temperature ,
         c.sale_order_id as saleOrderId,c.temperature_degree as temperaturee
        from ${appSettings.logistics_db}.container c
        where c.sale_order_id = ${req.saleOrderId}`

        const result = await manager.query(query55)
        if(result.length > 0){
            return new CommonResponse(true, 1,'Data retrieved successfully', result)
        }else{
            return new CommonResponse(false, 0,'No data found',[])
        }

    }catch(err){
        throw(err)

    }
    
    }



    async bookContainer(containerInfo: BookContainerDto): Promise<BookingContainerResponse> {
        const transactionManager = new GenericTransactionManager()
try{
    await transactionManager.startTransaction()
    let flagMap = new Set<boolean>()
    console.log(containerInfo,'rrrrrrr');
    const bookingEntity = await this.adapter.convertBookingDtoToEntity(containerInfo);
    const response = await this.repository.save(bookingEntity);

    if (response) {
        flagMap.add(true)
        const containerStatusInSo: SoContainerStatusUpdate = {
            saleOrderId: containerInfo.saleOrderId,
            containerStatus: ContainerStatusEnum.BOOKED
        }
        // update sale tracker status
        for(const val of containerInfo.marksAndNo){
            console.log(val,'oqks,dqw');
            
            const updateSaleItem = await this.soService.updateMarksAndNo(val)
                console.log(updateSaleItem,'updateSaleItem');
                
            if(updateSaleItem.status){
                flagMap.add(true)
            }else{
                flagMap.add(false)
                
            }
        }
        const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
        
        //container log data
        const containerLogData = new containerLogDto(ContainerStatusEnum.BOOKED, response.containerId, containerInfo.createdUser, containerInfo.updatedUser)

        const logResponse = await this.updateLog(containerLogData);
        if (flagMap.has(false)) {
            throw new ErrorResponse(1111, 'Something went wrong ')
          }
        return new BookingContainerResponse(true, 1111, 'Container Booked Successfully');
    } else {
        throw new ErrorResponse(9999, 'Failed to book the container');
    }
}catch(err){
    throw err
}
       

    }


    //checklist
    async checklist(containerInfo: BookContainerDto): Promise<BookingContainerResponse> {
        const getcheckListStatus = await this.repository.findOne({where:{saleOrderId:containerInfo.saleOrderId}})
        const checklist = Number(getcheckListStatus.checkListStatus)+1
        const bookingEntity = await this.adapter.convertContainerDtoToEntity(containerInfo,checklist);
        const response = await this.repository.save(bookingEntity);

        if (response) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.LOADED_AND_SEALED
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);

            //container log data
            const containerLogData = new containerLogDto(ContainerStatusEnum.BOOKED, response.containerId, containerInfo.createdUser, containerInfo.updatedUser)

            const logResponse = await this.updateLog(containerLogData);
            return new BookingContainerResponse(true, 1111, 'Container Booked Successfully');
        } else {
            throw new ErrorResponse(9999, 'Failed to book the container');
        }

    }

    async postShipmentDetails(containerInfo: BookContainerDto): Promise<BookingContainerResponse> {
        const getShipmentDetailsStatus = await this.repository.findOne({where:{saleOrderId:containerInfo.saleOrderId}})
        const shippmentDetails = Number(getShipmentDetailsStatus.checkListStatus)+1
        const bookingEntity = await this.adapter.convertPostShipmentDtoToEntity(containerInfo,shippmentDetails);
        const response = await this.repository.save(bookingEntity);
        

        if (response) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                // containerStatus: ContainerStatusEnum.LOADED_AND_SEALED
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);

            //container log data
            const containerLogData = new containerLogDto(ContainerStatusEnum.SHIPPED, response.containerId, containerInfo.createdUser, containerInfo.updatedUser)

            const logResponse = await this.updateLog(containerLogData);
            return new BookingContainerResponse(true, 1111, 'Container Booked Successfully');
        } else {
            throw new ErrorResponse(9999, 'Failed to book the container');
        }
    }

    async containerDispatchedToPlant(containerInfo: DispatchedToPlant): Promise<ContainerDispatchedToPlantResponse> {
        const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            containerNumber: containerInfo.containerNumber,
            containerSize: containerInfo.containerSize,
            containerStatus: containerInfo.containerStatus,
        })

        //container log data
        const containerLogData = new containerLogDto(ContainerStatusEnum.DISPATCHED_TO_PLANT, containerInfo.containerId, containerInfo.createdUser, containerInfo.updatedUser)

        const logResponse = await this.updateLog(containerLogData);

        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.DISPATCHED_TO_PLANT
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ContainerDispatchedToPlantResponse(true, 1111, 'Container Dispatched To Plant');
        } else {
            throw new ErrorResponse(9999, 'Failed to dispatch the container');
        }
    }

    async updateLog(conLog: containerLogDto) {
        const containerLogEntity = await this.logAdapter.convertDtoEntity(conLog);
        //save container log
        const containerLogResponse = await this.containerLogRepo.save(containerLogEntity);
    }

    async confirmOrAssignSo(containerInfo: ConfirmOrAssignSoData): Promise<ConfirmOrAssignSoResponse> {
        try {
            let response;
            if (containerInfo.saleOrderId != containerInfo.oldSoNumber) {
                const saleInfo = await this.repository.findOne({ where: { saleOrderId: containerInfo.saleOrderId } });
                if (saleInfo) {
                    const statuses = [ContainerStatusEnum.LOADING, ContainerStatusEnum.LOADED_AND_SEALED, ContainerStatusEnum.SHIPPED];
                    if (!statuses.includes(saleInfo.containerStatus)) {
                        // update container with current changed so
                        response = await this.repository.update({ containerId: containerInfo.containerId }, {
                            // containerStatus: containerInfo.containerStatus,
                            saleOrderId: containerInfo.saleOrderId,
                            updatedUser: containerInfo.updatedUser,
                            loadingStatus: ContainerLoadingStatus.LOADED
                        })
                        const containerStatusSo: SoContainerStatusUpdate = {
                            saleOrderId: containerInfo.saleOrderId,
                            containerStatus: ContainerStatusEnum.LOADING
                        }
                        await this.soService.updateContainerStatus(containerStatusSo)
                        // update old container status
                        const response1 = await this.repository.update({ containerId: saleInfo.containerId }, {
                            // containerStatus: saleInfo.containerStatus,
                            saleOrderId: containerInfo.oldSoNumber,
                            updatedUser: containerInfo.updatedUser,
                            loadingStatus: ContainerLoadingStatus.OPEN
                        })

                    } else {
                        throw new ErrorResponse(9999, "Container status can't be changed, container is in " + `${saleInfo.containerStatus}` + " status. Please Contact Admin");
                    }
                } else {
                    // update container with current changed so
                    response = await this.repository.update({ containerId: containerInfo.containerId }, {
                        // containerStatus: containerInfo.containerStatus,
                        saleOrderId: containerInfo.saleOrderId,
                        updatedUser: containerInfo.updatedUser,
                        loadingStatus: ContainerLoadingStatus.LOADED
                    })
                    const containerStatusInSo: SoContainerStatusUpdate = {
                        saleOrderId: containerInfo.oldSoNumber,
                        containerStatus: ContainerStatusEnum.READY_TO_BOOK
                    }
                    const containerStatusSo: SoContainerStatusUpdate = {
                        saleOrderId: containerInfo.saleOrderId,
                        containerStatus: ContainerStatusEnum.LOADING
                    }
                    await this.soService.updateContainerStatus(containerStatusSo)
                    // update sale tracker status
                    const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
                }
            } else {
                response = await this.repository.update({ containerId: containerInfo.containerId }, {
                    // containerStatus: containerInfo.containerStatus,
                    saleOrderId: containerInfo.saleOrderId,
                    updatedUser: containerInfo.updatedUser,
                    loadingStatus: ContainerLoadingStatus.LOADED
                })
                const containerStatusSo: SoContainerStatusUpdate = {
                    saleOrderId: containerInfo.saleOrderId,
                    containerStatus: ContainerStatusEnum.LOADING
                }
                await this.soService.updateContainerStatus(containerStatusSo)
            }



            if (response.affected) {
                // const containerStatusInSo: SoContainerStatusUpdate = {
                //     saleOrderId: containerInfo.saleOrderId,
                //     // containerStatus: ContainerStatusEnum.LOADING
                // }
                // // update sale tracker status
                // const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
                // //container log data
                // const containerLogData = new containerLogDto(ContainerStatusEnum.LOADING, containerInfo.containerId, containerInfo.createdUser, containerInfo.updatedUser)
                // const logResponse = await this.updateLog(containerLogData);
                return new ConfirmOrAssignSoResponse(true, 1111, 'So Confirmed To Container');
            } else {
                throw new ErrorResponse(9999, 'Failed to Update Container So');
            }
        } catch (error) {
            return error;
        }

    }


    async fillSealInfo(containerInfo: ContainerDTO): Promise<FillSealInfoResponse> {
        const dispatchContainer = await this.adapter.convertFillSealInfoDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            containerStatus: containerInfo.containerStatus,
            // lineSeal: containerInfo.lineSeal,
            eSeal: containerInfo.eSeal,
            driverName: containerInfo.driverName,
            // vehicleNumber: containerInfo.vehicleNumber,
            driverPhoneNumber: containerInfo.driverPhoneNumber,
            loadingDate: containerInfo.loadingDate,
            // scac: containerInfo.scac
        })

        if (response.affected) {

            //container log data
            const containerLogData = new containerLogDto(containerInfo.containerStatus, containerInfo.containerId, containerInfo.createdUser, containerInfo.updatedUser)

            const logResponse = await this.updateLog(containerLogData);

            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.LOADED_AND_SEALED,
                is_dispatched: true
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new FillSealInfoResponse(true, 1111, 'Seal Info Filled');
        } else {
            throw new ErrorResponse(9999, 'Failed to Fill Seal Info');
        }
    }

    async updateToReadyToBook(containerInfo: DispatchedToPlant): Promise<ContainerDispatchedToPlantResponse> {
        // const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            // containerNumber: containerInfo.containerNumber,
            containerStatus: ContainerStatusEnum.READY_TO_BOOK,
        })

        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.READY_TO_BOOK
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ContainerDispatchedToPlantResponse(true, 1111, 'Updated to Ready To Book');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

    async updateToBooked(containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        // const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            containerNumber: containerInfo.containerNo,
            containerStatus: ContainerStatusEnum.BOOKED,
        })
        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.BOOKED
            }

            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ContainerDispatchedToPlantResponse(true, 1111, 'Updated to Booked');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }
    async updateStatusToLoading(containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        // const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            containerNumber: containerInfo.containerNo,
            containerStatus: ContainerStatusEnum.LOADING,
            loadingStatus: ContainerLoadingStatus.LOADED
        })
        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.LOADING
            }

            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ContainerDispatchedToPlantResponse(true, 1111, 'Updated to LOADING');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }


    async updateToDispatchedToPlant(containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        // const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            // containerNumber: containerInfo.containerNumber,
            containerStatus: ContainerStatusEnum.DISPATCHED_TO_PLANT,
            loadingStatus: ContainerLoadingStatus.OPEN
        })

        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.DISPATCHED_TO_PLANT
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ContainerDispatchedToPlantResponse(true, 1111, 'Updated to Container Dispatched To Plant');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

    async updateToLoading(containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        // const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            // containerNumber: containerInfo.containerNumber,
            containerStatus: ContainerStatusEnum.LOADING,
            loadingStatus: ContainerLoadingStatus.LOADED
        })

        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.LOADING
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ContainerDispatchedToPlantResponse(true, 1111, 'Updated to Loading');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }
    async updateToLoadedAndSealed(containerInfo: ContainerStatusInfo): Promise<ConfirmOrAssignSoResponse> {
        // const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            // containerNumber: containerInfo.containerNumber,
            containerStatus: ContainerStatusEnum.LOADED_AND_SEALED,
        })

        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.LOADED_AND_SEALED
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ConfirmOrAssignSoResponse(true, 1111, 'Updated to Loaded and Sealed');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

    async initiateDispatch(containerInfo: ContainerStatusInfo): Promise<InitiateDispatchResponse> {
        try {
            const response = await this.repository.update({ containerId: containerInfo.containerId }, {
                containerStatus: ContainerStatusEnum.LOADING
            })
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.LOADING
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            //container log data
            const containerLogData = new containerLogDto(ContainerStatusEnum.LOADING, containerInfo.containerId, containerInfo.createdUser, containerInfo.updatedUser)

            const logResponse = await this.updateLog(containerLogData);
            return new InitiateDispatchResponse(true, 1111, 'Dispatch Initiated')
        } catch (error) {
            return error
        }

    }

    async shipContainer(containerInfo: ContainerStatusInfo): Promise<ContainerResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            let flag = true;
            const response = await manager.getCustomRepository(ContainerRepository).update({ containerId: containerInfo.containerId }, { containerStatus: ContainerStatusEnum.SHIPPED });
            if (response.affected <= 0) {
                flag = false;
                await manager.releaseTransaction();
                return new ContainerResponse(false, 1110, 'Something went wrong.');
            }
            else {
                const containerStatusInSo: SoContainerStatusUpdate = {
                    saleOrderId: containerInfo.saleOrderId,
                    containerStatus: ContainerStatusEnum.SHIPPED
                }
                // update sale tracker status
                const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
                if (containerStatusUpdate) {

                    const fgStockUpdate = await this.fGStockService.moveLeftOverQtytoDummy(new SoIdRequest(containerInfo.saleOrderId, containerInfo.plantId));
                                        if (!fgStockUpdate.status) {
                        flag = false;
                        await manager.releaseTransaction();
                        return new ContainerResponse(false, 1110, 'Something went wrong.');
                        // break;
                    }
                    console.log("fgStockUpdate" + fgStockUpdate.status + "***" + fgStockUpdate.data);

                    //moving left over packing Qty into bulk
                    const PackStockUpdate = await this.stockService.moveLeftOverQtyIntoBulk(new SaleOrderIdRequest(containerInfo.saleOrderId, null))
                    if (!PackStockUpdate.status) {
                        flag = false;
                        await manager.releaseTransaction();
                        return new ContainerResponse(false, 1110, 'Something went wrong.');
                    }

                }
                else {
                    flag = false;
                    await manager.releaseTransaction();
                    return new ContainerResponse(false, 1110, 'Something went wrong.');
                }


                //container log data
                const containerLogData = new containerLogDto(ContainerStatusEnum.SHIPPED, containerInfo.containerId, containerInfo.createdUser, containerInfo.updatedUser)

                const containerLogEntity = await this.logAdapter.convertDtoEntity(containerLogData);
                //save container log
                const containerLogResponse = await manager.getCustomRepository(ContainerLogRepository).save(containerLogEntity);
                if (!containerLogResponse.containerLogId) {
                    flag = false;
                    await manager.releaseTransaction();
                    return new ContainerResponse(false, 1110, 'Something went wrong.');
                }
                // const logResponse = await this.updateLog(containerLogData);

            }
            if (!flag) {
                await manager.releaseTransaction();
                return new ContainerResponse(false, 1110, 'Something went wrong.');
            }
            else {
                await manager.completeTransaction();
                return new ContainerResponse(true, 1111, 'Container Shipped Successfully');
            }
        } catch (error) {
            await manager.releaseTransaction();
            return error
        }

    }



    // ========================================================
    // ---------------- BL Status Services --------------------
    // ========================================================

    // async getAllContainerBlStatusInfo(): Promise<AllBlStatusInfo> {
    //     const containerInfo = await this.repository.find();
    //     const soTrackInfo = await this.soService.getSoTrackBlStatusInfo();

    //     if (soTrackInfo.status || containerInfo.length) {
    //         const containersInfo: BlStatusInfo[] = [];

    //         for (const container of containerInfo) {
    //             // get sale order details for sale order id
    //             const soReq: saleOrder = {
    //                 saleOrderId: container.saleOrderId
    //             }

    //             const saleOrderDetails = await this.soService.getSaleOrderDetailsForId(soReq);
    //             if (!saleOrderDetails) {
    //                 throw new ErrorResponse(1111, 'Failed to Get Sale Order');
    //             }
    //             const containerData = new BlStatusInfo(container.containerNumber, container.blStatus, saleOrderDetails, container.containerId);
    //             containersInfo.push(containerData);
    //         }
    //         if (soTrackInfo.status) {
    //             for (const soTrack of soTrackInfo.data) {
    //                 containersInfo.push(soTrack)
    //             }
    //         }


    //         return new AllBlStatusInfo(true, 1111, 'Container BL Status Info Found Successfully', containersInfo);
    //     } else {
    //         throw new ErrorResponse(9999, 'No Data Found')
    //     }
    // }

    async getAllContainerBlStatusInfo(req: UnitRequest): Promise<AllBlStatusInfo> {
        // const manager = getManager();
        // let query = `SELECT cn.container_number AS containerNo, st.container_status AS containerStatus,so.sale_order_id AS saleOrderId,so.sale_order_no AS saleOrderNumber,
        // cn.loading_status AS loadingStatus,cn.created_user AS createdUser,cn.container_id AS containerId,cn.updated_user AS updatedUser,inv.po_number AS poNo,
        // cn.reference_number AS referenceNumber,cn.scac AS scac,inv.buyer_po_number AS buyerPoNo,c.client_name AS customer, inv.act_edl_date AS etd,
        // ec.end_customer_name AS endCustomer,d.destination_name AS destination,IF(si.gross_weight_per_kg > 0, true, false) AS grossWeight,u.unit_code_id AS plantId,u.unit_name AS plant, so.is_invoiced AS isInvoiced, GROUP_CONCAT(file_path) AS filePath, 
        // cn.container_number AS containerNo, blStatus, so.sale_order_no as saleOrderNo, cn.container_id AS containerId, inv.act_edl_date AS etd, oblEtd, blNo, inv.po_number AS customPoNo, d.destination_name AS destination, cn.tracking_no as trackingNo FROM `+ appSettings.sales_db + `.sale_order so 
        // LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=so.sale_order_id
        // LEFT JOIN `+ appSettings.sales_db + `.sale_order_items si ON si.sale_order_id=so.sale_order_id AND si.gross_weight_per_kg = (SELECT MAX(gross_weight_per_kg) FROM  ` + appSettings.sales_db + `.sale_order_items si WHERE si.sale_order_id = so.sale_order_id)
        // LEFT JOIN `+ appSettings.masters_db + `.customers c ON c.cust_id=inv.customer_id
        // LEFT JOIN `+ appSettings.masters_db + `.end_customers ec ON ec.end_customer_id=inv.end_customer_id
        // LEFT JOIN `+ appSettings.masters_db + `.destination d ON d.destination_id=inv.destination
        // LEFT JOIN `+ appSettings.logistics_db + `.container cn ON inv.sale_order_id = cn.sale_order_id
        // LEFT JOIN `+ appSettings.logistics_db + `.documents_list doc ON cn.sale_order_id = doc.sale_order_id
        // LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.unit_code_id=inv.factoryId
        // LEFT JOIN `+ appSettings.sales_db + `.sale_order_track st ON st.sale_order_id=inv.sale_order_id where inv.job_type!='${JobTypesEnum.SUB_JOB}'`;

        // if ((([
        //     EmployeeRolesEnum.ADMIN,
        //     EmployeeRolesEnum.HO_PACKAGING_MANAGER
        // ].indexOf(req.role)) === -1) && !req.unitId) {
        //     query += ` and inv.factoryId= ${req.unitId}`;
        // }

        // query += ` group by so.sale_order_id`;
        // const queryResult = await manager.query(query);








        // const containerInfo = await this.repository.find({ where: { containerStatus: ContainerStatusEnum.SHIPPED } });
        const manager = getManager()


        // console.log(containerInfo);
        // const containersInfo: BlStatusInfo[] = [];

        // if (containerInfo.length > 0) {
        //     const containersInfo: BlStatusInfo[] = [];

        //     for (const container of containerInfo) {
        // get sale order details for sale order id
        //     const soReq: saleOrder = {
        //         saleOrderId: container.saleOrderId
        //     }

        //     const saleOrderDetails = await this.soService.getSaleOrderDetailsById(soReq);
        //     if (!saleOrderDetails) {
        //         throw new ErrorResponse(1111, 'Failed to Get Sale Order');
        //     }
        //     const SaleOrderDropDownData = new SaleOrderDropDownDto(saleOrderDetails.status ? saleOrderDetails.data.saleOrderId : 0, saleOrderDetails.status ? saleOrderDetails.data.saleOrder : "")
        //     const containerData = new BlStatusInfo(container.containerNumber, container.blStatus, SaleOrderDropDownData, (saleOrderDetails?.data?.saleOrder) ? saleOrderDetails.data.saleOrder : '', container.containerId, container.etd, container.oblEtd, container.blNo, saleOrderDetails ? saleOrderDetails.data.poNo : "", saleOrderDetails ? saleOrderDetails.data.finalDestination : "", container.trackingNo);
        //     containersInfo.push(containerData);
        // }

       let query = `select c.sale_order_id as saleOrderId, c.container_number as containerNumber,c.bl_status as blStatus,so.sale_order_no as saleOrder,c.container_id as containerId,c.etd as etd,c.obl_etd as obletd,c.bl_no as blNo,sid.po_number as poNo,sid.destination as finalDestination,c.tracking_no as trackingNo,d.destination_name as destinationName,sid.buyer_po_number as buyerPoNumber,ci.invoice_number as invoiceNumber,c.post_shipment_received_status as postShipmentReceivedStatus,ci.financial_year from ` + appSettings.logistics_db + `.container c left join ` + appSettings.sales_db + `.sale_order so on so.sale_order_id = c.sale_order_id left join ` + appSettings.sales_db + `.so_invoice_details sid on sid.sale_order_id = c.sale_order_id left join ` + appSettings.masters_db + `.destination d on destination_id = sid.destination  left join ` + appSettings.sales_db + `.customer_invoice ci on ci.sale_order_id = so.sale_order_id and ci.is_active =1 where c.status = 'SHIPPED' AND ci.is_active=1`
        if (req. financialYear != undefined) {
            query += ` and ci.financial_year = '${req. financialYear}'`;
        }
        if (req. destinationId != undefined) {
            query += ` and sid.destination = ${req. destinationId}`;
        }
        const data = await manager.query(query)

        const containerData = data.map((i => { return new BlStatusInfo(i.containerNumber, i.blStatus, new SaleOrderDropDownDto(i.saleOrderId, i.saleOrder), i.saleOrder, i.containerId, i.etd, i.oblEtd, i.blNo, i.poNo, i.finalDestination, i.trackingNo, i.destinationName, i.buyerPoNumber,i.invoiceNumber,i.postShipmentReceivedStatus) }));

        if (data) {

            return new AllBlStatusInfo(true, 1111, 'Container BL Status Info Found Successfully', containerData);
        } else {
            return new AllBlStatusInfo(false, 1101, 'No Data Found', containerData);

            // throw new ErrorResponse(9999, 'No Data Found')
        }
    }

    async notReceived(containerInfo: DraftReceived): Promise<DraftReceivedResponse> {
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            // containerNumber: containerInfo.containerNo,
            blStatus: BlStatusEnum.NOT_RECEIVED,
        })

        if (response.affected) {
            const blStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrder.saleOrderId,
                blStatus: BlStatusEnum.NOT_RECEIVED
            }
            // update sale tracker status
            const blStatusUpdate = await this.soService.updateBlStatus(blStatusInSo);
            return new DraftReceivedResponse(true, 1111, 'Updated to Not Received');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

    async draftReceived(containerInfo: DraftReceived): Promise<DraftReceivedResponse> {
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            // containerNumber: containerInfo.containerNo,
            blStatus: BlStatusEnum.DRAFT_RECEIVED,
        })

        if (response.affected) {
            const blStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrder.saleOrderId,
                blStatus: BlStatusEnum.DRAFT_RECEIVED,
                soStatus: SaleOrderStatusEnum.IN_PROGRESS
            }
            // update sale tracker status
            const blStatusUpdate = await this.soService.updateBlStatus(blStatusInSo);
            return new DraftReceivedResponse(true, 1111, 'Updated to Draft Received');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

    async oblReceived(containerInfo: DraftReceived): Promise<DraftReceivedResponse> {
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            containerNumber: containerInfo.containerNo,
            blStatus: BlStatusEnum.OBL_RECEIVED,
            etd: containerInfo.etd,
            // blNo:containerInfo.blNo,
        })

        if (response.affected) {
            const blStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrder.saleOrderId,
                blStatus: BlStatusEnum.OBL_RECEIVED,
                soStatus: SaleOrderStatusEnum.IN_PROGRESS
            }
            // update sale tracker status
            const blStatusUpdate = await this.soService.updateBlStatus(blStatusInSo);
            return new DraftReceivedResponse(true, 1111, 'Updated to OBL Received');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

    async receivedAndShared(containerInfo: DraftReceived): Promise<DraftReceivedResponse> {
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            containerNumber: containerInfo.containerNo,
            blStatus: BlStatusEnum.RECEIVED_AND_SHARED,
        })

        if (response.affected) {
            const blStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrder.saleOrderId,
                blStatus: BlStatusEnum.RECEIVED_AND_SHARED,
                soStatus: SaleOrderStatusEnum.CLOSED
            }
            const soStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrder.saleOrderId,
                soStatus: SaleOrderStatusEnum.CLOSED
            }
            // update sale tracker status
            const blStatusUpdate = await this.soService.updateBlStatus(blStatusInSo);
            // const soStatusUpdate = await this.soService.updateSoStatusForBl(soStatusInSo);
            return new DraftReceivedResponse(true, 1111, 'Updated to Received and Shared');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }
    async updateEtd(containerInfo: EtdUpdateRequest): Promise<DraftReceivedResponse> {
        if (containerInfo.type === "etd") {
            const response = await this.repository.update({ containerId: containerInfo.containerId }, {
                etd: containerInfo.etd
            });
            if (response.affected) {
                return new DraftReceivedResponse(true, 1111, 'ETD updated Successfully');
            } else {
                throw new ErrorResponse(9999, 'Failed to update');
            }
        }
        else if (containerInfo.type === "oblEtd") {
            const response = await this.repository.update({ containerId: containerInfo.containerId }, {
                oblEtd: containerInfo.etd
            });
            if (response.affected) {
                return new DraftReceivedResponse(true, 1111, 'ETD updated Successfully');
            } else {
                throw new ErrorResponse(9999, 'Failed to update');
            }
        }

    }
    async updateBlNo(containerInfo: BillNoUpdateRequest): Promise<DraftReceivedResponse> {
        try {
            const response = await this.repository.update({ containerId: containerInfo.containerId }, {
                blNo: containerInfo.blNo
            });
            if (response.affected) {
                return new DraftReceivedResponse(true, 1111, 'BlNo updated Successfully');
            } else {
                throw new ErrorResponse(9999, 'Failed to update');
            }
        }
        catch (err) {
            return err;
        }
    }
    /**
    * To get containerNumber,lineSeal,Eseal
    * @Param saleOrderId
    */
    async getContainerDeatils(soId: ContainerSoIdRequest): Promise<ContainerDetailsResponse> {
        const containerDetails = await this.repository.findOne({ where: { saleOrderId: soId.saleOrderId } });
        if (containerDetails) {
            const modelResponse = new ContainerDetailsModel(containerDetails.containerNumber, containerDetails.lineSeal, containerDetails.eSeal, containerDetails.blNo, containerDetails.scac, containerDetails.bookingNo, containerDetails.containerStatus, containerDetails.referenceNumber, containerDetails.trackingNo, containerDetails.vesselName, containerDetails.portOfTranshipment, containerDetails.portOfDischarge, containerDetails.importingVesselName, containerDetails.dateOfTranshipment, containerDetails.shippedOnboardDate, containerDetails.dischargeDate, containerDetails.destinationDate,containerDetails.tempIndicatorNo1,containerDetails.tempIndicatorNo2,containerDetails.tempIndicatorNo3,containerDetails.temperaturee,containerDetails.etd,containerDetails.containerSize,containerDetails.vesselNumber,containerDetails?.modeOfExport);
            return new ContainerDetailsResponse(true, 1111, 'Data Received Successfully', modelResponse)
        } else {
            return new ContainerDetailsResponse(false, 1011, 'No Data Found')
        }
    }

    async getLoadingReportDetails(): Promise<AllLoadingReportResponse> {
        const containerDetails = this.repository.createQueryBuilder('Container');
        const containerInfo = await containerDetails.getMany();
        const loadReportData: LoadingReportModel[] = [];
    

        if (containerInfo.length > 0) {
            // console.log(containerInfo,'oooooooooooooooooo');
            
            for (const container of containerInfo) {
                try {
                    // Fetch necessary details for the container
                    const custInvoiceDetails = await this.soService.getCustInvoiceDetails({
                        saleOrderId: container.saleOrderId,
                        plantId: container.unitId,
                    });
                     const docApprovalDetails = await this.soService.getDocumentApprovalStatus({
                        saleOrderId: container.saleOrderId,
                        plantId: container.unitId,
                    });

                     const soInspectionDetails = await this.soService.getSoInspectionDetails({
                        saleOrderId: container.saleOrderId,
                        plantId: container.unitId,
                    });
                     const SaleOrderItemDetails = await this.soService.getSaleOrderDetailsById({
                        saleOrderId: container.saleOrderId,
                    });
    // console.log('888888888888888888888');
    
                    // if (!SaleOrderItemDetails?.status || !SaleOrderItemDetails?.data) {
                    //     // console.warn('Invalid SaleOrderItemDetails:', SaleOrderItemDetails);
                    //     // continue;
                    // }
    
                    let docStatus = false;
                    let isfWorksheetUploaded = false;
    
                    if (docApprovalDetails.status) {
                        isfWorksheetUploaded = docApprovalDetails.data.isfWorksheetUploaded;
                        docStatus =
                            docApprovalDetails.data.simp_uploaded &&
                            docApprovalDetails.data.certificate_of_origin_uploaded &&
                            docApprovalDetails.data.declaration_of_shrimp_uploaded &&
                            docApprovalDetails.data.bLDraftUploaded &&
                            docApprovalDetails.data.oblUploaded;
                    }
    
                    let oblStatus = 'NO';
                    if (
                        container.blStatus === BlStatusEnum.OBL_RECEIVED ||
                        container.blStatus === BlStatusEnum.RECEIVED_AND_SHARED
                    ) {
                        oblStatus = 'YES';
                    }
    
                    let taxAmnt = 0;
                    let totalAmount = 0;
                    let FOBInRs = 0;
                    let FOBInUSD = 0;
    
                    if (SaleOrderItemDetails?.data?.itemData?.length > 0) {
                        for (const item of SaleOrderItemDetails.data.itemData) {
                            const uom = UnitsOfWeightInput.find((uom) => uom.value == item.uomId);
    
                            const taxPer = item.taxPer || 0;
                            taxAmnt += (item.netAmount * taxPer) / 100;
    
                            let finalNetWeight = Number(item.netWeight);
                            let unitPrice = Number(item.unitPrice).toFixed(4);
    
                            if (uom?.name === UomEnum.LB || uom?.name === UomEnum.OZ) {
                                finalNetWeight *= 0.454; // Convert to KG
                                unitPrice = (Number(item.unitPrice) / 0.454).toFixed(4);
                            }
    
                            totalAmount += Number(unitPrice) * finalNetWeight;
                        }
    
                        FOBInRs =
                            totalAmount -
                            Number(custInvoiceDetails.status ? custInvoiceDetails.data.freightCharges : 0);
                            FOBInUSD = Number(
                                (FOBInRs *
                                    Number(custInvoiceDetails.status ? custInvoiceDetails.data.exchangeRate : 0)
                                ).toFixed(2)
                            );
                            
                    } else {
                        // console.warn('No item data available for sale order:', SaleOrderItemDetails?.data?.saleOrder);
                    }
    
                    const loadReport = new LoadingReportModel(
                        SaleOrderItemDetails?.data?.consignee,
                        custInvoiceDetails?.data?.portOfLoading,
                        SaleOrderItemDetails.data.finalDestination,
                        container.shippingBillNo,
                        SaleOrderItemDetails.data.actualEtd,
                        container.containerNumber,
                        container.lineSeal,
                        'CMA CGM LYRA VOY-0TUGZE1MA',
                        container.blNo,
                        container.etd,
                        container.blStatus,
                        SaleOrderItemDetails.data.poNo,
                        '',
                        SaleOrderItemDetails.data.additionalNote,
                        custInvoiceDetails.status ? 'YES' : 'NO',
                        oblStatus,
                        docApprovalDetails.status ? docApprovalDetails.data.certificateOfOriginUploaded : false,
                        docStatus,
                        container.referenceNumber,
                        soInspectionDetails.status ? soInspectionDetails.data.isChecked : 'NO',
                        custInvoiceDetails.status ? custInvoiceDetails.data.totalAmount : 0,
                        SaleOrderItemDetails.data.shippingTerms,
                        FOBInUSD,
                        FOBInRs,
                        taxAmnt,
                        SaleOrderItemDetails.data.saleOrder,
                        container.hoCertificateNo,
                        container.hoCertificateNo !== null,
                        docApprovalDetails.status ? docApprovalDetails.data.declarationOfShrimpUploaded : false,
                        isfWorksheetUploaded,
                        container.shippingBillNo !== null,
                        SaleOrderItemDetails.data.paymentTerms,
                        container.insuranceType,
                        SaleOrderItemDetails.data.processingUnit,
                        SaleOrderItemDetails.data.processingUnit,

                        SaleOrderItemDetails.data.endCustomer,
                        'plant',
                        SaleOrderItemDetails.data.soStatus,
                        container.containerStatus,
                        '-',
                        SaleOrderItemDetails.data.soStatus,
                        custInvoiceDetails.data.invoiceNumber,
                    );
    
                    loadReportData.push(loadReport);

                } catch (error) {
                    // console.error('Error processing container:', container, error);
                    // continue;
                }
            }
    
            return new AllLoadingReportResponse(true, 1111, 'Report Details obtained', loadReportData);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }
    

    async updateShipmentDetails(req: ShipmentDetailsDto): Promise<ContainerDetailsResponse> {
        try {
            const containerDetails = await this.repository.findOne({ containerId: req.containerId });
            if (containerDetails != undefined) {
                const updateShipmentDetails = await this.repository.update({ containerId: req.containerId }, { trackingNo: req.trackingNo, vesselName: req.vesselName, portOfTranshipment: req.portOfTranshipment, portOfDischarge: req.portOfDischarge, importingVesselName: req.importingVesselName, dateOfTranshipment: req.dateOfTranshipment, shippedOnboardDate: req.shippedOnboardDate, dischargeDate: req.dischargeDate, destinationDate: req.destinationDate, hoCertificateNo: req.hoCertificateNo, hoIssuedDate: req.hoIssuedDate, vcNo: req.vcNo, documentDispatchStatus: req.documentDispatchStatus, documentDispatchDate: req.documentDispatchDate, couriourNo: req.couriourNo, insuranceType: req.insuranceType, shippingBillNo: req.shippingBillNo, insuranceId: req.insuranceId, insuranceDate: req.insuranceDate, referenceNo: req.referenceNo, insuranceAmount: req.insuranceAmount, shippingBillDate: req.shippingBillDate, bookingNo: req.bookingNo, scac: req.scac,leoDate:req.leoDate,brcRelDate:req.brcRelDate });
                if (updateShipmentDetails.affected > 0) {
                    return new ContainerDetailsResponse(true, 1001, "Shipment details updated successfully. ");
                }
                else {
                    return new ContainerDetailsResponse(false, 1001, "Shipment details updated successfully. ");
                }
            }
            else {
                return new ContainerDetailsResponse(false, 1001, "Container Details not found. ");
            }
        } catch (err) {
            return err;
        }
    }

    async getShipmentDetails(req: ContainerIdRequest): Promise<ShippmentDetailsResponse> {
        try {
            const manager = getManager();
            const getShippmentDetails = await this.repository.findOne({ containerId: req.containerId });
            const query =`SELECT co.sale_order_id,sid.po_number AS poNumber FROM ${appSettings.logistics_db}.container co
            LEFT JOIN ${appSettings.sales_db}.so_invoice_details sid ON sid.sale_order_id=co.sale_order_id
            WHERE co.sale_order_id=${getShippmentDetails.saleOrderId}`
            const soData =await manager.query(query)
            const poNumber = soData.length > 0 ? soData[0].poNumber : null;
            console.log(poNumber,"!!!!!!!!!!!!!!!!!")
            if (getShippmentDetails != undefined) {
                const data = new ShipmentDetailsDto(getShippmentDetails.containerId, getShippmentDetails.containerNumber, getShippmentDetails.dateOfTranshipment, getShippmentDetails.destinationDate, getShippmentDetails.dischargeDate, getShippmentDetails.importingVesselName, getShippmentDetails.portOfDischarge, getShippmentDetails.portOfTranshipment, getShippmentDetails.shippedOnboardDate, getShippmentDetails.trackingNo, getShippmentDetails.vesselName, getShippmentDetails.hoCertificateNo, getShippmentDetails.hoIssuedDate, getShippmentDetails.vcNo, getShippmentDetails.documentDispatchStatus, getShippmentDetails.couriourNo, getShippmentDetails.documentDispatchDate, getShippmentDetails.insuranceType, getShippmentDetails.shippingBillNo, getShippmentDetails.insuranceId, getShippmentDetails.insuranceDate, getShippmentDetails.referenceNo, getShippmentDetails.insuranceAmount, getShippmentDetails.shippingBillDate, getShippmentDetails.bookingNo, getShippmentDetails.scac,getShippmentDetails.leoDate,getShippmentDetails.brcRelDate,getShippmentDetails.saleOrderId,poNumber,getShippmentDetails.etd);
                return new ShippmentDetailsResponse(true, 1001, "Shippment Details retrived successfully. ", data);
            }
            else {
                return new ShippmentDetailsResponse(false, 1010, "No data found. ");
            }
        }
        catch (err) {
            return err;
        }
    }

    async getContainerReportData(): Promise<ContainerReportResponse> {
        const containerdata = await this.containerLogRepo.getContainerReportData();
        if (!containerdata.length) {
            throw new ErrorResponse(9999, 'No Data Found');
        }
        const statusMap: Map<ContainerStatusEnum | BlStatusEnum | string, Map<number, number>> = new Map();
        const plantsSet: Set<number> = new Set();
        for (const [key, value] of Object.entries(ContainerStatusEnum)) {
            statusMap.set(value, new Map());
        }
        for (const [key, value] of Object.entries(BlStatusEnum)) {
            statusMap.set(value, new Map());
        }
        containerdata.forEach(rec => {
            if (!statusMap.has(rec.status)) {
                statusMap.set(rec.status, new Map());
            }
            if (!statusMap.get(rec.status).has(rec.unit_id)) {
                statusMap.get(rec.status).set(rec.unit_id, rec.qty ? rec.qty : 0);
            }
            plantsSet.add(rec.unit_id);
        });
        const data: ContainerReportModel[] = [];
        for (const [status, plantMap] of statusMap.entries()) {
            const plantsData: ContainerReportPlantsData[] = []
            let total = 0;
            plantsSet.forEach(plant => {
                const qty = Number(plantMap.get(plant) ? plantMap.get(plant) : 0);
                total += qty;
                plantsData.push(new ContainerReportPlantsData(plant, qty));
            })
            data.push(new ContainerReportModel(status, plantsData, total));
        }
        return new ContainerReportResponse(true, 1, '', data);
    }

    async getLogisticsLifeCycleData(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            // let query = 'SELECT container_status AS STATUS ,SUM(IF(unit_id = 1, 1, 0)) AS kakinada,SUM(IF(unit_id=2, 1,0))AS unitone,SUM(IF(unit_id  = 3, 1, 0)) AS unittwo,COUNT(st.container_status) AS total FROM `erpx_dev_sales`.`sale_order_track` st  LEFT JOIN `erpx_dev_logistics`.`container` C ON C.sale_order_id=st.sale_order_id WHERE st.so_status NOT IN("CLOSE","CANCEL") GROUP BY container_status UNION ALL SELECT st.bl_status ,SUM(IF(unit_id = 1, 1, 0)) AS kakinada,SUM(IF(unit_id=2, 1,0))AS unitone,SUM(IF(unit_id  = 3, 1, 0)) AS unittwo,COUNT(st.bl_status) AS total  FROM `erpx_dev_sales`.`sale_order_track` st LEFT JOIN `erpx_dev_logistics`.`container` C ON C.sale_order_id=st.sale_order_id WHERE st.so_status NOT IN("CLOSE","CANCEL") GROUP BY st.bl_status'

            let query = 'SELECT container_status AS STATUS ,SUM(IF(unit_id = 1, 1, 0)) AS BMRINDUSTRIESIND,SUM(IF(unit_id=2, 1,0))AS SNOWWORLD,SUM(IF(unit_id  = 25, 1, 0)) AS BMRINDUSTRIESEXP,COUNT(st.container_status) AS total FROM erpx_dev_sales.sale_order_track st  LEFT JOIN erpx_dev_logistics.container C ON C.sale_order_id=st.sale_order_id WHERE st.so_status NOT IN("CLOSE","CANCEL") GROUP BY container_status UNION ALL SELECT st.bl_status ,SUM(IF(unit_id = 1, 1, 0)) AS "BMRINDUSTRIES-IND",SUM(IF(unit_id=2, 1,0))AS "SNOWWORLD",SUM(IF(unit_id  = 25, 1, 0)) AS "BMRINDUSTRIES-EXP",COUNT(st.bl_status) AS total  FROM erpx_dev_sales.sale_order_track st LEFT JOIN erpx_dev_logistics.container C ON C.sale_order_id = st.sale_order_id WHERE st.so_status NOT IN("CLOSE","CANCEL") GROUP BY st.bl_status'
            
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
            } else {
                return new CommonResponse(false, 1111, "Error occure")

            }

        } catch (err) {
            return err;
        }
    }
    async getMonthWiseContainersData(req: ContainerYearRequest): Promise<ContainerBarChartResponseModel> {
        try {
            const manager = getManager();
            let query = 'SELECT MONTHNAME(st.dispatched_date)AS MONTH,COUNT(si.sale_order_id) AS containers,SUM(IF(u.uom_name = "OZ" ,ROUND (si.dispatched_qty * si.pouches * si.pouch_weight * 0.0625), IF(u.uom_name = "KG" ,ROUND(si.dispatched_qty * si.pouches * si.pouch_weight*2.204),IF(uom_name = "GM" ,ROUND(si.dispatched_qty * si.pouches * si.pouch_weight * 0.0022),ROUND(si.dispatched_qty * si.pouches * si.pouch_weight)))))AS quantity FROM ' + appSettings.sales_db + '.sale_order_track st LEFT JOIN ' + appSettings.sales_db + '.sale_order_items si ON si.sale_order_id = st.sale_order_id LEFT JOIN ' + appSettings.masters_db + '.uoms u ON u.uom_id = si.uom_id WHERE st.container_status ="Shipped" AND dispatched_date IS NOT NULL AND YEAR(st.dispatched_date)=' + req.year + ' GROUP BY MONTH(st.dispatched_date)';
            // if(req.year){
            //     query=query + ' and YEAR(st.dispatched_date) = ' +req.year ;
            // }
            const result: ContainerBarChartDto[] = await manager.query(query)
            if (result) {
                return new ContainerBarChartResponseModel(true, 1111, "Data retreived sucesssfuly", result)
            } else {
                return new ContainerBarChartResponseModel(false, 1111, "Error occure")

            }

        } catch (err) {
            return err;
        }

    }
    async getTopFiveDestinations(): Promise<CommonResponse> {
        const todayDate = moment().format("DD-MM-YYYY")
        const currentMonth = moment(todayDate).get('month')
        const lastYear = moment().subtract(1, 'year').get('year')
        const currentYear = moment().get('year')
        let fromDate;
        if (currentMonth < 4) {
            fromDate = '01-04-' + lastYear
        } else {
            fromDate = '01-04-' + currentYear
        }

        try {
            const manager = getManager();
            let query = ' SELECT d.destination_name AS destination, COUNT(d.destination_name) AS count FROM ' + appSettings.sales_db + '.so_invoice_details s LEFT JOIN ' + appSettings.masters_db + '.destination d ON s.destination = d.destination_id LEFT JOIN ' + appSettings.masters_db + '.unitcodes uc ON uc.unit_code_id = s.factoryId LEFT JOIN ' + appSettings.sales_db + ' .sale_order_track st ON s.sale_order_id=st.sale_order_id WHERE st.container_status = "SHIPPED" AND st.dispatched_date BETWEEN ' + fromDate + ' AND NOW() GROUP BY destination ORDER BY COUNT(destination) DESC LIMIT 5';
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)

            } else {
                return new CommonResponse(false, 1111, "Error occure")

            }
        } catch (err) {
            return err;

        }
    }
    async gettotalsaleorderShipped(req: ContainerYearRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = 'SELECT MONTHNAME(dispatched_date) AS name,COUNT(sale_order_id) AS y,MONTHNAME(dispatched_date) AS drilldown FROM ' + appSettings.sales_db + '.`sale_order_track` WHERE so_status="CLOSED" AND dispatched_date IS NOT NULL AND YEAR(dispatched_date) =' + req.year + ' GROUP BY MONTHNAME(dispatched_date) ORDER BY MONTH(dispatched_date)';
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1111, "Data Retreived sucessfully", result)
            } else {
                return new CommonResponse(false, 1111, "Error occure")
            }
        } catch (err) {
            return err;
        }
    }
    async totalsaleordersshiipedinyear(req: ContainerYearRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = 'SELECT COUNT(sale_order_id) as total FROM ' + appSettings.sales_db + '.sale_order_track WHERE so_status="CLOSED" AND dispatched_date IS NOT NULL AND YEAR(dispatched_date)=' + req.year + '';
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1111, "Data Retreived sucessfully", result)
            } else {
                return new CommonResponse(false, 1111, "Error occure")
            }
        } catch (err) {
            return err;
        }
    }
    async totalsaleordersShippedinDayWise(req: ContainerYearRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = `SELECT NAME as name,id,CONCAT('[',GROUP_CONCAT(CONCAT('["',DAY,'",',cnt,']')  ORDER BY DAY DESC SEPARATOR ','),']') AS data FROM (SELECT MONTH(dispatched_date) AS MONTH, MONTHNAME(dispatched_date) AS NAME, MONTHNAME(dispatched_date) AS id ,COUNT(sale_order_id) cnt,DATE(dispatched_date) DAY FROM erpx_dev_sales.sale_order_track WHERE so_status='CLOSED' AND dispatched_date IS NOT NULL AND YEAR(dispatched_date) = ` + req.year + ` GROUP BY MONTH(dispatched_date), DAY(dispatched_date)ORDER BY DAY(dispatched_date)) q GROUP BY NAME ORDER BY MONTH`
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1111, "Data Retrieved sucessfully", result)
            } else {
                return new CommonResponse(false, 1111, "Error occured")
            }
        } catch (err) {

            return err;

        }
    }


    async getLogisticsDailUsage() {
        try {
            const manager = getManager();
            const query = `select count(*) as count,cl.status as containerStatus,c.unit_id as unitId,uc.unit_name as unitName from ${appSettings.logistics_db}.container_log cl
         left join ${appSettings.logistics_db}.container c on c.container_id = cl.container_id 
         left join ${appSettings.masters_db}.unitcodes uc on uc.unit_code_id = c.unit_id
         where DATE(cl.created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY)
         group by cl.status,c.unit_id `
            const data = await manager.query(query)
            const time = moment().subtract(1, "days").format('MMMM Do, YYYY')
            const groupByStatus = data.reduce((group, containerData) => {
                const { containerStatus } = containerData;
                group[containerStatus] = group[containerStatus] ?? [];
                group[containerStatus].push(containerData ? containerData : 'no data')
                return group;
            }, {})
            const message = Object.keys(groupByStatus).length ? (`Logistics usage on ${time} \n` + Object.keys(groupByStatus).map((key) => {
                return `\n*${key}:*\n  ${groupByStatus[key].map((el) => { return el.unitName + ':' + el.count + '\n' })}`
            })) : (`Logistics usage on ${time} \n\n *No data found for all units*`)
            const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(35, message.toString(), [whatsApp.UsageReport]));
            if (messageStatus.status) {
                return new CommonResponse(true, 11108, "Message Sent Sucessfully", messageStatus)
            } else {
                return new CommonResponse(false, 11108, "Error while sending message", messageStatus)
            }
        } catch (error) {
            return new CommonResponse(false, 11508, "Error while sending message")
        }
    }

    @Cron('1 * * * *')
    async getLogisticsDailyUsage() {
        const manager = getManager();
        const time = moment().subtract(1, "days").format('MMMM Do, YYYY')
        const units = [{ unitName: 'Kakinada', id: 1 }, { unitName: 'Unit 1', id: 2 }, { unitName: 'Unit 2', id: 3 }, { unitName: 'Head Office', id: 5 }]
        const query = `SELECT c.unit_id as unitId,
            SUM(IF( cl.status = 'BOOKED',1,0)) AS booked ,
            SUM(IF( cl.status = 'SHIPPED',1,0)) AS shipped ,
            SUM(IF( cl.status = 'DISPATCHED TO PLANT',1,0)) AS dispatchedToPlant ,
            SUM(IF( cl.status = 'LOADED AND SEALED',1,0)) AS loadedAndSealed ,
            SUM(IF( cl.status = 'LOADING',1,0)) AS loading ,
            u.unit_name AS unit FROM container_log cl
            LEFT JOIN container c ON c.container_id = cl.container_id 
            LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id = c.unit_id
            where DATE(cl.created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY)
            GROUP BY c.unit_id`

        const containerData = await manager.query(query);
        const inVoicesQuery = `SELECT i.unit_id as unitId,COUNT(*)AS invoiceCount,uc.unit_name AS unitName FROM ${appSettings.sales_db}.customer_invoice i
        LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id=i.unit_id 
        where DATE(i.created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY) and i.is_active =1
        GROUP BY i.unit_id`

        const invoicesData = await manager.query(inVoicesQuery)

        let invoicesCount = '';
        let unitWiseData = '';
        let bookedData = '';
        let shippedData = '';
        let oblData = '';
        let invoiceData = '';
        let docApprovalPendData = '';

        for (const u of units) {
            const unitWisefilteredData = containerData.filter((i) => i.unitId == u.id)
            unitWiseData += `*${u.unitName}:* ` + ((unitWisefilteredData.length > 0) ? (unitWisefilteredData.map((el) => { return ` \\n BOOKED : ${el.booked} \\n SHIPPED : ${el.shipped} \\n DISPATCHED TO PLANT : ${el.dispatchedToPlant} \\n LOADED AND SEALED : ${el.loadedAndSealed} \\n LOADING : ${el.loading} \\n\\n` })) : (` \\n BOOKED : ${0} \\n SHIPPED : ${0} \\n DISPATCHED TO PLANT : ${0} \\n LOADED AND SEALED : ${0} \\n LOADING : ${0} \\n \\n`));

            const unitWiseInvoiceData = invoicesData.filter((i) => i.unitId == u.id);
            invoicesCount += `*${u.unitName}:* ` + ((unitWiseInvoiceData.length > 0) ? (unitWiseInvoiceData[0].invoiceCount + "\\n") : (0 + "\\n"))
        }


        const message = `*Logistics usage on ${time}*\\n *CONTAINER STATUS* \n\n ${unitWiseData} \\n *INVOICES COUNT*\\n\\n ${invoicesCount} `
        // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(35, message.toString(), [whatsApp.UsageReport]));
        const parameters = [
            { "type": "text", "text": time + ` (${whatsApp.server})` },
            { "type": "text", "text": unitWiseData },
            { "type": "text", "text": invoicesCount },
            // { "type": "text", "text": "No Data" },
            // { "type": "text", "text": "No Data" },
            // { "type": "text", "text": "No Data" },

        ]
        const contacts = whatsApp.contacts
        let statusFlag = true
        for (const contact of contacts) {
            const req = await new MessageParameters(contact, 'logistics_report', parameters, "en_us")
            const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
            if (!messageStatus.status) {
                statusFlag = false
            }
            else {
                statusFlag = true
                const whatsapplogDto = new WhatsAppLogDto(contact, 'logistics_report', 'Sandhya', GlobalVariableValues.companyId, GlobalVariableValues.logisticsmoduleId)
                await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)

            }
        }
        if (statusFlag) {
            return new CommonResponse(true, 11108, "Message Sent Sucessfully")
        } else {
            return new CommonResponse(false, 11108, "Error while sending message")
        }
    }

    async getSoIdsByStatus(soId: ContainerStatusRequest): Promise<CommonResponse> {
        const manager = getManager();
        const data = "Select DISTINCT(sale_order_id) AS soIds,freight_after_shipment as freight from " + appSettings.logistics_db + ".container c where status = 'SHIPPED'"
        const containerDetails = await manager.query(data);
        if (containerDetails) {
            return new CommonResponse(true, 1111, 'Data Received Successfully', containerDetails)
        } else {
            return new CommonResponse(false, 1011, 'No Data Found')
        }
    }

    async createLoadingSheet(req: LoadingSheetReqDto): Promise<CommonResponse> {
        try {
            const entity = new Container()
            entity.containerId = req.containerId
            entity.saleOrderId = req.saleOrderId

            let loadingSheetArray = []


            for (const loadingSheet of req.loadingSheetReq) {
                const loadingSheetEntity = new LoadingSheetEntity()
                loadingSheetEntity.loadingSheetId = loadingSheet.loadingSheetId
                loadingSheetEntity.loadingSheetNumber = loadingSheet.loadingSheetNumber
                loadingSheetEntity.lotNumber = loadingSheet.lotNumber
                loadingSheetEntity.variety = loadingSheet.variety
                loadingSheetEntity.grade = loadingSheet.grade
                loadingSheetEntity.count = loadingSheet.count
                loadingSheetEntity.saleOrderId = req.saleOrderId

                loadingSheetArray.push(loadingSheetEntity)

            }
            entity.loadingSheet = loadingSheetArray

            const save = await this.soLoadingSheetRepo.save(entity)
            if (save) {
                return new CommonResponse(true, 1, 'Created Sucessfully')
            } else {
                return new CommonResponse(false, 0, 'Something Went Wrong')

            }
        }
        catch (err) {
            throw err
        }
    }



    async getLoadingSheetDescriptionDetails(req: LoadingSheetSaleOrderReq): Promise<CommonResponse> {
        try {
            let query = ` SELECT so.sale_order_id AS saleOrderId,po_number AS poNumber ,sale_order_item_id AS saleOrderItemId,
          brand_name AS brandName,co.container_number FROM
        ` + appSettings.sales_db + `.sale_order_items so
        LEFT JOIN  ` + appSettings.sales_db + `.so_invoice_details sd ON sd.sale_order_id=so.sale_order_id
        LEFT JOIN  ` + appSettings.masters_db + `.brands b ON b.brand_id=so.brand_id
        LEFT JOIN  ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id=so.varient_id 
        LEFT JOIN ` + appSettings.logistics_db+ `.container co ON co.sale_order_id=so.sale_order_id
        WHERE  so.sale_order_id = '${req.saleOrderId}'
        GROUP BY so.sale_order_id
       ;`
            const data = await this.soLoadingSheetRepo.query(query)

            if (data.length > 0) {
                return new CommonResponse(true, 0, "Declaration Form Details retrieved successfully", data)
            } else {
                return new CommonResponse(false, 1, "No data found", [])
            }
        } catch (err) {
            throw (err)
        }

    }

    async documentApprovelOpenShipment(containerInfo: FreightAfterShipmentDto): Promise<CommonResponse> {
        try {
          const bookingEntity = await this.adapter.convertDoccumentApprovelOpenDtoToEntity(containerInfo);
          const existingRecord = await this.repository.findOne({ where: { saleOrderId: containerInfo.saleOrderId } });
          
          if (!existingRecord) {
            return new CommonResponse(false, 404, 'Record not found');
          }
          
          this.repository.merge(existingRecord, bookingEntity);
      
          const response = await this.repository.save(existingRecord);
          return new CommonResponse(true, 1111, 'Freight After Shipment Updated Successfully', response);
        } catch (error) {
          return new CommonResponse(false, 0, error.toString());
        }
      }
      
    //   @Cron('30 7 * * *')
    //   async getDailySheetData(req:DailySheetData): Promise<CommonResponse> {
    //     try {
    //         const manager=getManager()
    //         const moment = require('moment');
    //         const yesterdayDate = moment().subtract(1,'day').format('YYYY-MM-DD');
    //         console.log(yesterdayDate,"yesterdayDate")


    //         const time = moment().subtract(1, "days").format('MMMM Do, YYYY');
    //         const nowTime = moment().subtract(0, "days").format('MMMM Do, YYYY')

    
    //         let query = ` SELECT COUNT(sale_order_id),date(created_at) as date FROM  ` + appSettings.sales_db + ` .sale_order  WHERE DATE(created_at) = "${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}"
    //         GROUP BY CAST(created_at AS DATE) ;`
    //         // console.log(DATE(created_at))
    //         let query2=`SELECT COUNT(purchase_order_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .purchase_order WHERE DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE) `
    //         let query3=`SELECT COUNT(grn_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .grn WHERE DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE)  `
    //         let query4=`SELECT COUNT(stock_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .stock WHERE DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE)   `
    //         let query5=`SELECT COUNT(indent_material_preparation_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .indent_material_preparation WHERE DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE) `
    //         let query6=`SELECT COUNT(indent_form_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .packing_indent WHERE DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE) `
    //         let query7=`SELECT COUNT(store_consumption_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .store_consumption WHERE DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE)             `
    //         let query8=`SELECT COUNT(indent_id),CAST(created_at AS DATE) FROM ` + appSettings.rm_procure_db + ` .indent WHERE DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE)             `
    //         let query9=`SELECT COUNT(indent_id),CAST(created_at AS DATE) FROM ` + appSettings.rm_procure_db + ` .indent WHERE vehicle_assigned = 1 AND DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}"  GROUP BY CAST(created_at AS DATE)             `
    //         let query10=`SELECT COUNT(grn_id),CAST(created_at AS DATE) FROM ` + appSettings.rm_procure_db + ` .grn WHERE DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE)             `
    //         let query11=`SELECT COUNT(stock_id),CAST(created_at AS DATE) FROM ` + appSettings.warehouse_db + ` .reporting WHERE (reported_cases > 0 OR loose_pouches > 0 ) AND DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE)             `
    //         let query12=`SELECT COUNT(job_id),CAST(created_at AS DATE) FROM ` + appSettings.warehouse_db + ` .fork_lift_jobs WHERE job_purpose = 'dispatch' AND DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE)             `
    //         let query13=`SELECT COUNT(container_log_id),CAST(created_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container_log WHERE STATUS = 'BOOKED' AND DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE)             `
    //         let query14=`SELECT COUNT(container_log_id),CAST(created_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container_log WHERE STATUS = 'LOADED AND SEALED' AND DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE)             `
    //         let query15=`SELECT COUNT(container_log_id),CAST(created_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container_log WHERE STATUS = 'SHIPPED' AND DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE)             `
    //         let query16=`SELECT COUNT(invoice_id),CAST(created_at AS DATE) FROM ` + appSettings.sales_db+ ` .customer_invoice WHERE DATE(created_at) ="${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" GROUP BY CAST(created_at AS DATE) `
    //         let query17 =`SELECT count(*) as Enq FROM `+ appSettings.enquiry_db+ ` .enquiries WHERE DATE(created_at) = "${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}" `
    //         let query18 = `SELECT count(*) as Cost FROM `+ appSettings.enquiry_db+ ` .cost_sheet WHERE DATE(created_at) = '${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}' `
    //         let query19 =`SELECT count(*) as Deheading FROM `+ appSettings.production_db+ ` .production_log WHERE DATE(created_at) = '${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}' AND operation = 'DEHEADING' `
    //         let query20 =`SELECT count(*) as Grading FROM `+ appSettings.production_db+ ` .production_log WHERE DATE(created_at) = '${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}' AND operation = 'GRADING' `
    //         let query21 = `SELECT count(*) as Value FROM `+appSettings.production_db+ ` .production_log WHERE DATE(created_at) = '${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}' AND operation = 'VALUE ADDITION' `
    //         let query22 =`SELECT count(*) as Soaking FROM `+appSettings.production_db+ ` .production_log WHERE DATE(created_at) = '${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}' AND operation = 'SOAKING' `
    //         let query23=`SELECT COUNT(*) as Non FROM `+appSettings.production_db+ ` .non_soaked_products WHERE DATE(created_at) = '${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}'`
    //         let collectionQuery=`SELECT COUNT(*) as counts  FROM ${appSettings.finance_db}.collections WHERE DATE(created_at) = '${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}'`
    //         let expensesQuery=`SELECT COUNT(*) as counts  FROM ${appSettings.finance_db}.expenses WHERE DATE(created_at) = '${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}'`
    //         let purchaseQuery=`SELECT COUNT(*) as counts  FROM ${appSettings.finance_db}.purchases WHERE DATE(created_at) = '${req.dailySheetdate ?req.dailySheetdate:yesterdayDate}'`

    //         const data =await manager.query(query)
    //         const data2 =await manager.query(query2)
    //         const data3 =await manager.query(query3)
    //         const data4 =await manager.query(query4)
    //         const data5 =await manager.query(query5)
    //         const data6 =await manager.query(query6)
    //         const data7=await manager.query(query7)
    //         const data8 =await manager.query(query8)
    //         const data9 =await manager.query(query9)
    //         const data10 =await manager.query(query10)
    //         const data11 =await manager.query(query11)
    //         const data12 =await manager.query(query12)
    //         const data13 =await manager.query(query13)
    //         const data14 =await manager.query(query14)
    //         const data15 =await manager.query(query15)
    //         const data16 =await manager.query(query16)
    //         const data17 =await manager.query(query17)
    //         const data18 =await manager.query(query18)
    //         const data19 =await manager.query(query19)
    //         const data20 =await manager.query(query20)
    //         const data21 =await manager.query(query21)
    //         const data22 =await manager.query(query22)
    //         const data23 =await manager.query(query23)
    //         const collectionData =await manager.query(collectionQuery)
    //         const expensesData =await manager.query(expensesQuery)
    //         const purchaseData =await manager.query(purchaseQuery)

           

           
    //         console.log(data17.length > 0 ? `Enquiries Count: ${data17[0].Enq}` : "Enquiries Count: 0");
    //         console.log(data18.length > 0 ? `Costsheet: ${data18[0].Cost}` : "Costsheet: 0");
    //         console.log(data.length > 0 
    //             ? `Sale Order Count: ${data[0]['COUNT(sale_order_id)']}` 
    //             : "Sale Order Count: 0"
    //           );
    //           console.log(data2.length > 0 ? `Purchase Order Count: ${data2[0]['COUNT(purchase_order_id)']}` : "Purchase Order Count: 0");
    //           console.log(data3.length > 0 ? `GRN Count: ${data3[0]['COUNT(grn_id)']}` : "GRN Count: 0");
    //           console.log(data4.length > 0 ? `Stock Count: ${data4[0]['COUNT(stock_id)']}` : "Stock Count: 0");
    //           console.log(data5.length > 0 ? `Material Requisition Count: ${data5[0]['COUNT(indent_material_preparation_id)']}` : "Material Requisition Count: 0");
    //           console.log(data6.length > 0 ? `Production Indent Count: ${data6[0]['COUNT(indent_form_id)']}` : "Production Indent Count: 0");
    //           console.log(data7.length > 0 ? `Material Issues Count: ${data7[0]['COUNT(store_consumption_id)']}` : "Material Issues Count: 0");
    //           console.log(data8.length > 0 ? `Indent Raised Count: ${data8[0]['COUNT(indent_id)']}` : "Indent Raised Count: 0");
    //           console.log(data9.length > 0 ? `Vehicle Assigned Count: ${data9[0]['COUNT(indent_id)']}` : "Vehicle Assigned Count: 0");
    //           console.log(data10.length > 0 ? `(RM) GRN Count: ${data10[0]['COUNT(grn_id)']}` : "(RM) GRN Count: 0");
    //           console.log(data11.length > 0 ? `STOCK IN Count: ${data11[0]['COUNT(stock_id)']}` : "STOCK IN Count: 0");
    //           console.log(data12.length > 0 ? `STOCK OUT Count: ${data12[0]['COUNT(stock_id)']}` : "STOCK OUT Count: 0");
    //           console.log(data13.length > 0 ? `Booked Count: ${data13[0]['COUNT(container_id)']}` : "Booked Count: 0");
    //           console.log(data14.length > 0 ? `Loaded Count: ${data14[0]['COUNT(container_id)']}` : "Loaded Count: 0");
    //           console.log(data15.length > 0 ? `SHIPPED Count: ${data15[0]['COUNT(container_id)']}` : "SHIPPED Count: 0");
    //           console.log(data16.length > 0 ? `Invoice Count: ${data16[0]['COUNT(invoice_id)']}` : "Invoice Count: 0");
    //           console.log(data19.length > 0 ? `Deheading reportings : ${data19[0].Deheading}` : "Deheading reportings : 0");
    //           console.log(data20.length > 0 ? `Grading Reportings: ${data20[0].Grading}` : "Grading Reportings: 0");
    //           console.log(data22.length > 0 ? `Soaking Reportings: ${data22[0].Soaking}` : "Soaking Reportings: 0");
    //           console.log(data21.length > 0 ? `value addition reportings: ${data21[0].Value}` : "value addition reportings: 0");
    //           console.log(data23.length > 0 ? `NOn soaked product reportings: ${data23[0].Non}` : "NOn soaked product reportings: 0");
    //           console.log(collectionData.length > 0 ? `Receivable: ${collectionData[0].counts}` : "Receivable: 0");
    //           console.log(expensesData.length > 0 ? `Expenses: ${expensesData[0].counts}` : "Expenses: 0");
    //           console.log(purchaseData.length > 0 ? `Purchases: ${purchaseData[0].counts}` : "Purchases: 0");



    //           const parameters = [
    //             { "type": "text", "text": `\\n *BMR Manufacturing Usage on* : ${req.dailySheetdate ? nowTime : time}\\n \\n *Enquiries & SO's*\\n------------------  \\n Enquiries: ${data17.length > 0 ? data17[0].Enq : 0} \\n Costsheet Generations : ${data18.length > 0 ? data18[0].Cost : 0} \\n Sale Orders : ${data.length > 0 ? data[0]['COUNT(sale_order_id)'] : 0} \\n \\n *Packing*\\n----------- \\n Purchase Orders : ${data2.length > 0 ? data2[0]['COUNT(purchase_order_id)'] : 0} \\n GRN's : ${data3.length > 0 ? data3[0]['COUNT(grn_id)'] : 0} \\n Stock : ${data4.length > 0 ? data4[0]['COUNT(stock_id)'] : 0} \\n Material Requisition : ${data5.length > 0 ? data5[0]['COUNT(indent_material_preparation_id)'] : 0} \\n Production Indent : ${data6.length > 0 ? data6[0]['COUNT(indent_form_id)'] : 0} \\n Material Issues : ${data7.length > 0 ? data7[0]['COUNT(store_consumption_id)'] : 0}\\n \\n *RM Procurement*\\n ---------------- \\n RM Indent's : ${data8.length > 0 ? data8[0]['COUNT(indent_id)'] : 0} \\n Vehicle Assigned : ${data9.length > 0 ? data9[0]['COUNT(indent_id)'] : 0} \\n RM GRN : ${data10.length > 0 ? data10[0]['COUNT(grn_id)'] : 0} \\n  \\n *Production*\\n-------------\\n Deheading Reportings : ${data19.length > 0 ? data19[0].Deheading : 0} \\n Grading Reportings : ${data20.length > 0 ? data20[0].Grading : 0} \\n Soaking Reportings : ${data22.length > 0 ? data22[0].Soaking : 0} \\n Value Addition Reportings : ${data21.length > 0 ? data21[0].Value : 0} \\n Non soaked Product Reportings : ${data23.length > 0 ? data23[0].Non : 0}\\n \\n*WareHouse*\\n--------------\\n  Stock IN : ${data11.length > 0 ? data11[0]['COUNT(stock_id)'] : 0} \\n  Stock OUT : ${data12.length > 0 ? data12[0]['COUNT(stock_id)'] : 0}\\n \\n*Logistics*\\n----------\\n Booked : ${data13.length > 0 ? data13[0]['COUNT(container_id)'] : 0} \\n Loaded : ${data14.length > 0 ? data14[0]['COUNT(container_id)'] : 0} \\n SHIPPED : ${data15.length > 0 ? data15[0]['COUNT(container_id)'] : 0} \\n Invoice : ${data16.length > 0 ? data16[0]['COUNT(invoice_id)'] : 0}\\n \\n*Finance*\\n---------\\n Receivable :${collectionData.length > 0 ? collectionData[0].counts : 0} \\n Expenses : ${expensesData.length > 0 ? expensesData[0].counts : 0} \\n Purchases :${purchaseData.length > 0 ? purchaseData[0].counts : 0}` }
    
    //           ]


    //           const contacts = whatsApp.contacts
    //           let statusFlag = true
    //           for (const contact of contacts) {
    //             const req = await new MessageParameters(contact, 'global_usage_report', parameters, 'en_us')
    //             const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
    //             console.log(messageStatus)
    //             if (!messageStatus.status) {
    //               statusFlag = false
    //             } else {
    //               statusFlag = true
    //               const whatsapplogDto = new WhatsAppLogDto(contact, 'global_usage_report', 'BMR', GlobalVariableValues.companyId, GlobalVariableValues.salemoduleId)
    //               await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
    //             }
    //           }
   
   

    //         if (statusFlag) {
    //             return new CommonResponse(true, 11108, "Message Sent Sucessfully")
              
    //         } else {
    //             return new CommonResponse(false, 1, "Error while sending message")
    //         }
    //     } catch (err) {
    //         throw (err)
    //     }

    // }
   
    
    @Cron('30 8 * * *')
    async getDailySheetData(): Promise<CommonResponse> {
      try {
          const manager = getManager()
          const moment = require('moment');
          const reqdate = moment().subtract(1,'day').format('YYYY-MM-DD');

          const dateAndTime = moment(reqdate, 'YYYY-MM-DD').format('MMMM Do, YYYY');

          let query = ` SELECT COUNT(sale_order_id),date(created_at) as date FROM  ` + appSettings.sales_db + ` .sale_order  WHERE DATE(created_at) = "${reqdate}"
          GROUP BY CAST(created_at AS DATE) ;`
          let query2=`SELECT COUNT(purchase_order_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .purchase_order WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE) `
          let query3=`SELECT COUNT(grn_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .grn WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)  `
          let query4=`SELECT COUNT(stock_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .stock WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)   `
          let query5=`SELECT COUNT(indent_material_preparation_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .indent_material_preparation WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE) `
          let query6=`SELECT COUNT(indent_form_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .packing_indent WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE) `
          let query7=`SELECT COUNT(store_consumption_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .store_consumption WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
          let query8=`SELECT COUNT(indent_id),CAST(created_at AS DATE) FROM ` + appSettings.rm_procure_db + ` .indent WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
          let query9=`SELECT COUNT(indent_id),CAST(created_at AS DATE) FROM ` + appSettings.rm_procure_db + ` .indent WHERE vehicle_assigned = 1 AND DATE(created_at) ="${reqdate}"  GROUP BY CAST(created_at AS DATE)             `
          let query10=`SELECT COUNT(grn_id),CAST(created_at AS DATE) FROM ` + appSettings.rm_procure_db + ` .grn WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
          let query11=`SELECT COUNT(stock_id),CAST(created_at AS DATE) FROM ` + appSettings.warehouse_db + ` .reporting WHERE (reported_cases > 0 OR loose_pouches > 0 ) AND DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
          let query12=`SELECT COUNT(job_id),CAST(created_at AS DATE) FROM ` + appSettings.warehouse_db + ` .fork_lift_jobs WHERE job_purpose = 'dispatch' AND DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
          let query13=`SELECT COUNT(container_log_id),CAST(created_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container_log WHERE STATUS = 'BOOKED' AND DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
          let query14=`SELECT COUNT(container_log_id),CAST(created_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container_log WHERE STATUS = 'LOADED AND SEALED' AND DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
          let query15=`SELECT COUNT(container_log_id),CAST(created_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container_log WHERE STATUS = 'SHIPPED' AND DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
          let query16=`SELECT COUNT(invoice_id),CAST(created_at AS DATE) FROM ` + appSettings.sales_db+ ` .customer_invoice WHERE DATE(created_at) ="${reqdate}" and is_active =1 GROUP BY CAST(created_at AS DATE) `
          let oblReceivedQuery=`SELECT COUNT(container_id),CAST(updated_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container WHERE bl_status="OBL RECEIVED" AND DATE(updated_at) ="${reqdate}" GROUP BY CAST(updated_at AS DATE) `
          let draftReceivedQuery=`SELECT COUNT(container_id),CAST(updated_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container WHERE bl_status="DRAFT RECEIVED" AND DATE(updated_at) ="${reqdate}" GROUP BY CAST(updated_at AS DATE) `
          let receivedAndSharedQuery=`SELECT COUNT(container_id),CAST(updated_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container WHERE bl_status="RECEIVED AND SHARED" AND DATE(updated_at) ="${reqdate}" GROUP BY CAST(updated_at AS DATE) `
          let query17 =`SELECT count(*) as Enq FROM `+ appSettings.enquiry_db+ ` .enquiries WHERE DATE(created_at) = "${reqdate}" `
          let query18 = `SELECT count(*) as Cost FROM `+ appSettings.enquiry_db+ ` .cost_sheet WHERE DATE(created_at) = '${reqdate}' `
          let query19 =`SELECT count(*) as Deheading FROM `+ appSettings.production_db+ ` .production_log WHERE DATE(created_at) = '${reqdate}' AND operation = 'DEHEADING' `
          let query20 =`SELECT count(*) as Grading FROM `+ appSettings.production_db+ ` .production_log WHERE DATE(created_at) = '${reqdate}' AND operation = 'GRADING' `
          let query21 = `SELECT count(*) as Value FROM `+appSettings.production_db+ ` .production_log WHERE DATE(created_at) = '${reqdate}' AND operation = 'VALUE ADDITION' `
          let query22 =`SELECT count(*) as Soaking FROM `+appSettings.production_db+ ` .production_log WHERE DATE(created_at) = '${reqdate}' AND operation = 'SOAKING' `
          let query23=`SELECT COUNT(*) as Non FROM `+appSettings.production_db+ ` .non_soaked_products WHERE DATE(created_at) = '${reqdate}'`
          let collectionQuery=`SELECT COUNT(*) as counts  FROM ${appSettings.finance_db}.collections WHERE DATE(created_at) = '${reqdate}'`
          let expensesQuery=`SELECT COUNT(*) as counts  FROM ${appSettings.finance_db}.expenses WHERE DATE(created_at) = '${reqdate}'`
          let purchaseQuery=`SELECT COUNT(*) as counts  FROM ${appSettings.finance_db}.purchases WHERE DATE(created_at) = '${reqdate}'`

          const data =await manager.query(query)
          const data2 =await manager.query(query2)
          const data3 =await manager.query(query3)
          const data4 =await manager.query(query4)
          const data5 =await manager.query(query5)
          const data6 =await manager.query(query6)
          const data7=await manager.query(query7)
          const data8 =await manager.query(query8)
          const data9 =await manager.query(query9)
          const data10 =await manager.query(query10)
          const data11 =await manager.query(query11)
          const data12 =await manager.query(query12)
          const data13 =await manager.query(query13)
          const data14 =await manager.query(query14)
          const data15 =await manager.query(query15)
          const oblReceived=await manager.query(oblReceivedQuery)
          const draftreceived=await manager.query(draftReceivedQuery)
          const receivedAndShared=await manager.query(receivedAndSharedQuery)
          const data16 =await manager.query(query16)
          const data17 =await manager.query(query17)
          const data18 =await manager.query(query18)
          const data19 =await manager.query(query19)
          const data20 =await manager.query(query20)
          const data21 =await manager.query(query21)
          const data22 =await manager.query(query22)
          const data23 =await manager.query(query23)
          const collectionData =await manager.query(collectionQuery)
          const expensesData =await manager.query(expensesQuery)
          const purchaseData =await manager.query(purchaseQuery)

         

         
        //   console.log(data17.length > 0 ? `Enquiries Count: ${data17[0].Enq}` : "Enquiries Count: 0");
        //   console.log(data18.length > 0 ? `Costsheet: ${data18[0].Cost}` : "Costsheet: 0");
        //   console.log(data.length > 0 
        //       ? `Sale Order Count: ${data[0]['COUNT(sale_order_id)']}` 
        //       : "Sale Order Count: 0"
        //     );
        //     console.log(data2.length > 0 ? `Purchase Order Count: ${data2[0]['COUNT(purchase_order_id)']}` : "Purchase Order Count: 0");
        //     console.log(data3.length > 0 ? `GRN Count: ${data3[0]['COUNT(grn_id)']}` : "GRN Count: 0");
        //     console.log(data4.length > 0 ? `Stock Count: ${data4[0]['COUNT(stock_id)']}` : "Stock Count: 0");
        //     console.log(data5.length > 0 ? `Material Requisition Count: ${data5[0]['COUNT(indent_material_preparation_id)']}` : "Material Requisition Count: 0");
        //     console.log(data6.length > 0 ? `Production Indent Count: ${data6[0]['COUNT(indent_form_id)']}` : "Production Indent Count: 0");
        //     console.log(data7.length > 0 ? `Material Issues Count: ${data7[0]['COUNT(store_consumption_id)']}` : "Material Issues Count: 0");
        //     console.log(data8.length > 0 ? `Indent Raised Count: ${data8[0]['COUNT(indent_id)']}` : "Indent Raised Count: 0");
        //     console.log(data9.length > 0 ? `Vehicle Assigned Count: ${data9[0]['COUNT(indent_id)']}` : "Vehicle Assigned Count: 0");
        //     console.log(data10.length > 0 ? `(RM) GRN Count: ${data10[0]['COUNT(grn_id)']}` : "(RM) GRN Count: 0");
        //     console.log(data11.length > 0 ? `STOCK IN Count: ${data11[0]['COUNT(stock_id)']}` : "STOCK IN Count: 0");
        //     console.log(data12.length > 0 ? `STOCK OUT Count: ${data12[0]['COUNT(job_id)']}` : "STOCK OUT Count: 0");
        //     console.log(data13.length > 0 ? `Booked Count: ${data13[0]['COUNT(container_log_id)']}` : "Booked Count: 0");
        //     console.log(data14.length > 0 ? `Loaded Count: ${data14[0]['COUNT(container_log_id)']}` : "Loaded Count: 0");
        //     console.log(data15.length > 0 ? `SHIPPED Count: ${data15[0]['COUNT(container_log_id)']}` : "SHIPPED Count: 0");
        //     console.log(oblReceived.length > 0 ? `OBL Received: ${oblReceived[0]['COUNT(container_id)']}` : "OBL Received: 0");
        //     console.log(draftreceived.length > 0 ? `Draft Received: ${draftreceived[0]['COUNT(container_id)']}` : "Draft Received: 0");
        //     console.log(receivedAndShared.length > 0 ? `Received And Shared: ${receivedAndShared[0]['COUNT(container_id)']}` : "Received And Shared: 0");

        //     console.log(data16.length > 0 ? `Invoice Count: ${data16[0]['COUNT(invoice_id)']}` : "Invoice Count: 0");
        //     console.log(data19.length > 0 ? `Deheading reportings : ${data19[0].Deheading}` : "Deheading reportings : 0");
        //     console.log(data20.length > 0 ? `Grading Reportings: ${data20[0].Grading}` : "Grading Reportings: 0");
        //     console.log(data22.length > 0 ? `Soaking Reportings: ${data22[0].Soaking}` : "Soaking Reportings: 0");
        //     console.log(data21.length > 0 ? `value addition reportings: ${data21[0].Value}` : "value addition reportings: 0");
        //     console.log(data23.length > 0 ? `NOn soaked product reportings: ${data23[0].Non}` : "NOn soaked product reportings: 0");
        //     console.log(collectionData.length > 0 ? `Receivable: ${collectionData[0].counts}` : "Receivable: 0");
        //     console.log(expensesData.length > 0 ? `Expenses: ${expensesData[0].counts}` : "Expenses: 0");
        //     console.log(purchaseData.length > 0 ? `Purchases: ${purchaseData[0].counts}` : "Purchases: 0");



            const response = {
                "Enquiries": data17.length > 0 ? data17[0].Enq : 0,
                "Costsheet": data18.length > 0 ? data18[0].Cost : 0,
                "Sale Order": data.length > 0 ? data[0]['COUNT(sale_order_id)'] : 0,
                "Purchase Order": data2.length > 0 ? data2[0]['COUNT(purchase_order_id)'] : 0,
                "GRN Count": data3.length > 0 ? data3[0]['COUNT(grn_id)'] : 0,
                "Stock Count": data4.length > 0 ? data4[0]['COUNT(stock_id)'] : 0,
                "Material Requisition": data5.length > 0 ? data5[0]['COUNT(indent_material_preparation_id)'] : 0,
                "Production Indent": data6.length > 0 ? data6[0]['COUNT(indent_form_id)'] : 0,
                "Material Issues": data7.length > 0 ? data7[0]['COUNT(store_consumption_id)'] : 0,
                "Indent Raised": data8.length > 0 ? data8[0]['COUNT(indent_id)'] : 0,
                "Vehicle Assigned": data9.length > 0 ? data9[0]['COUNT(indent_id)'] : 0,
                "(RM) GRN": data10.length > 0 ? data10[0]['COUNT(grn_id)'] : 0,
                "STOCK IN": data11.length > 0 ? data11[0]['COUNT(stock_id)'] : 0,
                "STOCK OUT": data12.length > 0 ? data12[0]['COUNT(job_id)'] : 0,
                "Booked": data13.length > 0 ? data13[0]['COUNT(container_log_id)'] : 0,
                "Loaded": data14.length > 0 ? data14[0]['COUNT(container_log_id)'] : 0,
                "OBL Received": oblReceived.length > 0 ? oblReceived[0]['COUNT(container_id)']: 0 ,
                "Draft Received": draftreceived.length > 0 ? draftreceived[0]['COUNT(container_id)']: 0 ,
                "Received And Shared": receivedAndShared.length > 0 ? receivedAndShared[0]['COUNT(container_id)']: 0 ,
                "SHIPPED": data15.length > 0 ? data15[0]['COUNT(container_log_id)'] : 0,
                "Invoice": data16.length > 0 ? data16[0]['COUNT(invoice_id)'] : 0,
                "Deheading Reportings": data19.length > 0 ? data19[0].Deheading : 0,
                "Grading Reportings": data20.length > 0 ? data20[0].Grading : 0,
                "Soaking Reportings": data22.length > 0 ? data22[0].Soaking : 0,
                "Value Addition Reportings": data21.length > 0 ? data21[0].Value : 0,
                "Non-soaked Product Reportings": data23.length > 0 ? data23[0].Non : 0,
                "Receivable": collectionData.length > 0 ? collectionData[0].counts : 0,
                "Expenses": expensesData.length > 0 ? expensesData[0].counts : 0,
                "Purchases": purchaseData.length > 0 ? purchaseData[0].counts : 0
            };



            const parameters = [
              { "type": "text", "text": `\r*${GlobalVariableValues.companyName}*\r*Usage on* : ${dateAndTime}(*${whatsApp.server}*)\r\r*Enquiries & SO's*\r------------------  \rEnquiries: ${data17.length > 0 ? data17[0].Enq : 0}\rCostsheet Generations : ${data18.length > 0 ? data18[0].Cost : 0}\rSale Orders : ${data.length > 0 ? data[0]['COUNT(sale_order_id)'] : 0}\r\r*Packing*\r-----------\rPurchase Orders : ${data2.length > 0 ? data2[0]['COUNT(purchase_order_id)'] : 0}\rGRN's : ${data3.length > 0 ? data3[0]['COUNT(grn_id)'] : 0}\rStock : ${data4.length > 0 ? data4[0]['COUNT(stock_id)'] : 0}\rMaterial Requisition : ${data5.length > 0 ? data5[0]['COUNT(indent_material_preparation_id)'] : 0}\rProduction Indent : ${data6.length > 0 ? data6[0]['COUNT(indent_form_id)'] : 0}\r Material Issues : ${data7.length > 0 ? data7[0]['COUNT(store_consumption_id)'] : 0}\r\r*RM Procurement*\r ---------------- \rRM Indent's : ${data8.length > 0 ? data8[0]['COUNT(indent_id)'] : 0}\rVehicle Assigned : ${data9.length > 0 ? data9[0]['COUNT(indent_id)'] : 0}\rRM GRN : ${data10.length > 0 ? data10[0]['COUNT(grn_id)'] : 0}\r\r *Production*\r-------------\rDeheading Reportings : ${data19.length > 0 ? data19[0].Deheading : 0}\rGrading Reportings : ${data20.length > 0 ? data20[0].Grading : 0}\rSoaking Reportings : ${data22.length > 0 ? data22[0].Soaking : 0}\rValue Addition Reportings : ${data21.length > 0 ? data21[0].Value : 0}\rNon soaked Product Reportings : ${data23.length > 0 ? data23[0].Non : 0}\r\r*WareHouse*\r--------------\rStock IN : ${data11.length > 0 ? data11[0]['COUNT(stock_id)'] : 0}\rStock OUT : ${data12.length > 0 ? data12[0]['COUNT(job_id)'] : 0}\r\r*Logistics*\r----------\rBooked : ${data13.length > 0 ? data13[0]['COUNT(container_log_id)'] : 0}\rLoaded : ${data14.length > 0 ? data14[0]['COUNT(container_log_id)'] : 0}\rSHIPPED : ${data15.length > 0 ? data15[0]['COUNT(container_log_id)'] : 0}\rOBL Received : ${oblReceived.length > 0 ? oblReceived[0]['COUNT(container_id)'] : 0}\rDraft Received : ${draftreceived.length > 0 ? draftreceived[0]['COUNT(container_id)'] : 0}\rReceived And Shared : ${receivedAndShared.length > 0 ? receivedAndShared[0]['COUNT(container_id)'] : 0}\rInvoice : ${data16.length > 0 ? data16[0]['COUNT(invoice_id)'] : 0}\r\r*Finance*\r---------\rReceivable :${collectionData.length > 0 ? collectionData[0].counts : 0}\rExpenses : ${expensesData.length > 0 ? expensesData[0].counts : 0}\rPurchases :${purchaseData.length > 0 ? purchaseData[0].counts : 0}` }
  
            ]
            // console.log(parameters,'parameters')


            const contacts = whatsApp.contacts
            let statusFlag = true
            for (const contact of contacts) {
              const req = await new MessageParameters(contact, 'global_usage_report', parameters, 'en_us')
              const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
            //   console.log(messageStatus)
              if (!messageStatus.status) {
                statusFlag = false
              } else {
                statusFlag = true
                const whatsapplogDto = new WhatsAppLogDto(contact, 'global_usage_report', 'BMR', GlobalVariableValues.companyId, GlobalVariableValues.salemoduleId)
                await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
              }
            }
 
            
 

          if (statusFlag) {
              return new CommonResponse(true, 11108, "Message Sent Sucessfully",response)
            
          } else {
              return new CommonResponse(false, 1, "Error while sending message")
          }
      } catch (err) {
          throw (err)
      }

  }

//   async getDailySheetData1(req:DailySheetData): Promise<CommonResponse> {
//     console.log(req,"lkjh")
//     try {
//         const manager = getManager()
//         let reqdate = req.dailySheetdate
//         let query
//         let query2
//         let query3
//         let query4
//         let query5
//         let query6
//         let query7
//         let query8
//         let query9
//         let query10
//         let query11
//         let query12
//         let query13
//         let query14
//         let query15
//         let query16
//         let query17
//         let query18
//         let query19
//         let query20
//         let query21
//         let query22
//         let query23
//         let oblReceivedQuery
//         let draftReceivedQuery
//         let receivedAndSharedQuery
//         let collectionQuery
//         let expensesQuery
//         let purchaseQuery





//         if (req.dailySheetdate){
//          query = ` SELECT COUNT(sale_order_id),date(created_at) as date FROM  ` + appSettings.sales_db + ` .sale_order  WHERE DATE(created_at) = "${reqdate}"
//         GROUP BY CAST(created_at AS DATE) ;`
//          query2=`SELECT COUNT(purchase_order_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .purchase_order WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE) `
//          query3=`SELECT COUNT(grn_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .grn WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)  `
//          query4=`SELECT COUNT(stock_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .stock WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)   `
//          query5=`SELECT COUNT(indent_material_preparation_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .indent_material_preparation WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE) `
//          query6=`SELECT COUNT(indent_form_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .packing_indent WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE) `
//          query7=`SELECT COUNT(store_consumption_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .store_consumption WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
//          query8=`SELECT COUNT(indent_id),CAST(created_at AS DATE) FROM ` + appSettings.rm_procure_db + ` .indent WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
//          query9=`SELECT COUNT(indent_id),CAST(created_at AS DATE) FROM ` + appSettings.rm_procure_db + ` .indent WHERE vehicle_assigned = 1 AND DATE(created_at) ="${reqdate}"  GROUP BY CAST(created_at AS DATE)             `
//          query10=`SELECT COUNT(grn_id),CAST(created_at AS DATE) FROM ` + appSettings.rm_procure_db + ` .grn WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
//          query11=`SELECT COUNT(stock_id),CAST(created_at AS DATE) FROM ` + appSettings.warehouse_db + ` .reporting WHERE (reported_cases > 0 OR loose_pouches > 0 ) AND DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
//          query12=`SELECT COUNT(job_id),CAST(created_at AS DATE) FROM ` + appSettings.warehouse_db + ` .fork_lift_jobs WHERE job_purpose = 'dispatch' AND DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
//          query13=`SELECT COUNT(container_log_id),CAST(created_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container_log WHERE STATUS = 'BOOKED' AND DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
//          query14=`SELECT COUNT(container_log_id),CAST(created_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container_log WHERE STATUS = 'LOADED AND SEALED' AND DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
//          query15=`SELECT COUNT(container_log_id),CAST(created_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container_log WHERE STATUS = 'SHIPPED' AND DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE)             `
//          query16=`SELECT COUNT(invoice_id),CAST(created_at AS DATE) FROM ` + appSettings.sales_db+ ` .customer_invoice WHERE DATE(created_at) ="${reqdate}" GROUP BY CAST(created_at AS DATE) `
//          oblReceivedQuery=`SELECT COUNT(container_id),CAST(updated_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container WHERE bl_status="OBL RECEIVED" AND DATE(updated_at) ="${reqdate}" GROUP BY CAST(updated_at AS DATE) `
//          draftReceivedQuery=`SELECT COUNT(container_id),CAST(updated_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container WHERE bl_status="DRAFT RECEIVED" AND DATE(updated_at) ="${reqdate}" GROUP BY CAST(updated_at AS DATE) `
//          receivedAndSharedQuery=`SELECT COUNT(container_id),CAST(updated_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container WHERE bl_status="RECEIVED AND SHARED" AND DATE(updated_at) ="${reqdate}" GROUP BY CAST(updated_at AS DATE) `
//          query17 =`SELECT count(*) as Enq FROM `+ appSettings.enquiry_db+ ` .enquiries WHERE DATE(created_at) = "${reqdate}" `
//          query18 = `SELECT count(*) as Cost FROM `+ appSettings.enquiry_db+ ` .cost_sheet WHERE DATE(created_at) = '${reqdate}' `
//          query19 =`SELECT count(*) as Deheading FROM `+ appSettings.production_db+ ` .production_log WHERE DATE(created_at) = '${reqdate}' AND operation = 'DEHEADING' `
//          query20 =`SELECT count(*) as Grading FROM `+ appSettings.production_db+ ` .production_log WHERE DATE(created_at) = '${reqdate}' AND operation = 'GRADING' `
//          query21 = `SELECT count(*) as Value FROM `+appSettings.production_db+ ` .production_log WHERE DATE(created_at) = '${reqdate}' AND operation = 'VALUE ADDITION' `
//          query22 =`SELECT count(*) as Soaking FROM `+appSettings.production_db+ ` .production_log WHERE DATE(created_at) = '${reqdate}' AND operation = 'SOAKING' `
//          query23=`SELECT COUNT(*) as Non FROM `+appSettings.production_db+ ` .non_soaked_products WHERE DATE(created_at) = '${reqdate}'`
//          collectionQuery=`SELECT COUNT(*) as counts  FROM ${appSettings.finance_db}.collections WHERE DATE(created_at) = '${reqdate}'`
//          expensesQuery=`SELECT COUNT(*) as counts  FROM ${appSettings.finance_db}.expenses WHERE DATE(created_at) = '${reqdate}'`
//          purchaseQuery=`SELECT COUNT(*) as counts  FROM ${appSettings.finance_db}.purchases WHERE DATE(created_at) = '${reqdate}'`
//         } else {
            

//          query = ` SELECT COUNT(sale_order_id),date(created_at) as date FROM  ` + appSettings.sales_db + ` .sale_order  WHERE DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query2=`SELECT COUNT(purchase_order_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .purchase_order WHERE DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query3=`SELECT COUNT(grn_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .grn WHERE DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query4=`SELECT COUNT(stock_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .stock WHERE DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query5=`SELECT COUNT(indent_material_preparation_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .indent_material_preparation WHERE DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query6=`SELECT COUNT(indent_form_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .packing_indent WHERE DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query7=`SELECT COUNT(store_consumption_id),CAST(created_at AS DATE) FROM ` + appSettings.procure_db + ` .store_consumption WHERE DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query8=`SELECT COUNT(indent_id),CAST(created_at AS DATE) FROM ` + appSettings.rm_procure_db + ` .indent WHERE DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query9=`SELECT COUNT(indent_id),CAST(created_at AS DATE) FROM ` + appSettings.rm_procure_db + ` .indent WHERE vehicle_assigned = 1 AND DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query10=`SELECT COUNT(grn_id),CAST(created_at AS DATE) FROM ` + appSettings.rm_procure_db + ` .grn WHERE DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query11=`SELECT COUNT(stock_id),CAST(created_at AS DATE) FROM ` + appSettings.warehouse_db + ` .reporting WHERE (reported_cases > 0 OR loose_pouches > 0 ) AND DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query12=`SELECT COUNT(job_id),CAST(created_at AS DATE) FROM ` + appSettings.warehouse_db + ` .fork_lift_jobs WHERE job_purpose = 'dispatch' AND DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query13=`SELECT COUNT(container_log_id),CAST(created_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container_log WHERE STATUS = 'BOOKED' AND DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query14=`SELECT COUNT(container_log_id),CAST(created_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container_log WHERE STATUS = 'LOADED AND SEALED' AND DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query15=`SELECT COUNT(container_log_id),CAST(created_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container_log WHERE STATUS = 'SHIPPED' AND DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query16=`SELECT COUNT(invoice_id),CAST(created_at AS DATE) FROM ` + appSettings.sales_db+ ` .customer_invoice WHERE DATE(created_at)  BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          oblReceivedQuery=`SELECT COUNT(container_id),CAST(updated_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container WHERE bl_status="OBL RECEIVED" AND  DATE(updated_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}" `
//          draftReceivedQuery=`SELECT COUNT(container_id),CAST(updated_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container WHERE bl_status="DRAFT RECEIVED" AND DATE(updated_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}" `
//          receivedAndSharedQuery=`SELECT COUNT(container_id),CAST(updated_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container WHERE bl_status="RECEIVED AND SHARED" AND DATE(updated_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}" `
//          query17 =`SELECT count(*) as Enq FROM `+ appSettings.enquiry_db+ ` .enquiries WHERE DATE(created_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          query18 = `SELECT count(*) as Cost FROM `+ appSettings.enquiry_db+ ` .cost_sheet WHERE DATE(created_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}" `
//          query19 =`SELECT count(*) as Deheading FROM `+ appSettings.production_db+ ` .production_log WHERE DATE(created_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}" AND operation = 'DEHEADING' `
//          query20 =`SELECT count(*) as Grading FROM `+ appSettings.production_db+ ` .production_log WHERE DATE(created_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}" AND operation = 'GRADING' `
//          query21 = `SELECT count(*) as Value FROM `+appSettings.production_db+ ` .production_log WHERE DATE(created_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}" AND operation = 'VALUE ADDITION' `
//          query22 =`SELECT count(*) as Soaking FROM `+appSettings.production_db+ ` .production_log WHERE DATE(created_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}" AND operation = 'SOAKING' `
//          query23=`SELECT COUNT(*) as Non FROM `+appSettings.production_db+ ` .non_soaked_products WHERE DATE(created_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          collectionQuery=`SELECT COUNT(*) as counts  FROM ${appSettings.finance_db}.collections WHERE DATE(created_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          expensesQuery=`SELECT COUNT(*) as counts  FROM ${appSettings.finance_db}.expenses WHERE DATE(created_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}"`
//          purchaseQuery=`SELECT COUNT(*) as counts  FROM ${appSettings.finance_db}.purchases WHERE DATE(created_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}"`

//         }

//         const data =await manager.query(query)
//         const data2 =await manager.query(query2)
//         const data3 =await manager.query(query3)
//         const data4 =await manager.query(query4)
//         const data5 =await manager.query(query5)
//         const data6 =await manager.query(query6)
//         const data7=await manager.query(query7)
//         const data8 =await manager.query(query8)
//         const data9 =await manager.query(query9)
//         const data10 =await manager.query(query10)
//         const data11 =await manager.query(query11)
//         const data12 =await manager.query(query12)
//         const data13 =await manager.query(query13)
//         const data14 =await manager.query(query14)
//         const data15 =await manager.query(query15)
//         const oblReceived=await manager.query(oblReceivedQuery)
//         const draftreceived=await manager.query(draftReceivedQuery)
//         const receivedAndShared=await manager.query(receivedAndSharedQuery)
//         const data16 =await manager.query(query16)
//         const data17 =await manager.query(query17)
//         const data18 =await manager.query(query18)
//         const data19 =await manager.query(query19)
//         const data20 =await manager.query(query20)
//         const data21 =await manager.query(query21)
//         const data22 =await manager.query(query22)
//         const data23 =await manager.query(query23)
//         const collectionData =await manager.query(collectionQuery)
//         const expensesData =await manager.query(expensesQuery)
//         const purchaseData =await manager.query(purchaseQuery)

       

       
//         // console.log(data17.length > 0 ? `Enquiries Count: ${data17[0].Enq}` : "Enquiries Count: 0");
//         // console.log(data18.length > 0 ? `Costsheet: ${data18[0].Cost}` : "Costsheet: 0");
//         // console.log(data.length > 0 
//         //     ? `Sale Order Count: ${data[0]['COUNT(sale_order_id)']}` 
//         //     : "Sale Order Count: 0"
//         //   );
//         //   console.log(data2.length > 0 ? `Purchase Order Count: ${data2[0]['COUNT(purchase_order_id)']}` : "Purchase Order Count: 0");
//         //   console.log(data3.length > 0 ? `GRN Count: ${data3[0]['COUNT(grn_id)']}` : "GRN Count: 0");
//         //   console.log(data4.length > 0 ? `Stock Count: ${data4[0]['COUNT(stock_id)']}` : "Stock Count: 0");
//         //   console.log(data5.length > 0 ? `Material Requisition Count: ${data5[0]['COUNT(indent_material_preparation_id)']}` : "Material Requisition Count: 0");
//         //   console.log(data6.length > 0 ? `Production Indent Count: ${data6[0]['COUNT(indent_form_id)']}` : "Production Indent Count: 0");
//         //   console.log(data7.length > 0 ? `Material Issues Count: ${data7[0]['COUNT(store_consumption_id)']}` : "Material Issues Count: 0");
//         //   console.log(data8.length > 0 ? `Indent Raised Count: ${data8[0]['COUNT(indent_id)']}` : "Indent Raised Count: 0");
//         //   console.log(data9.length > 0 ? `Vehicle Assigned Count: ${data9[0]['COUNT(indent_id)']}` : "Vehicle Assigned Count: 0");
//         //   console.log(data10.length > 0 ? `(RM) GRN Count: ${data10[0]['COUNT(grn_id)']}` : "(RM) GRN Count: 0");
//         //   console.log(data11.length > 0 ? `STOCK IN Count: ${data11[0]['COUNT(stock_id)']}` : "STOCK IN Count: 0");
//         //   console.log(data12.length > 0 ? `STOCK OUT Count: ${data12[0]['COUNT(job_id)']}` : "STOCK OUT Count: 0");
//         //   console.log(data13.length > 0 ? `Booked Count: ${data13[0]['COUNT(container_log_id)']}` : "Booked Count: 0");
//         //   console.log(data14.length > 0 ? `Loaded Count: ${data14[0]['COUNT(container_log_id)']}` : "Loaded Count: 0");
//         //   console.log(data15.length > 0 ? `SHIPPED Count: ${data15[0]['COUNT(container_log_id)']}` : "SHIPPED Count: 0");
//         //   console.log(oblReceived.length > 0 ? `OBL Received: ${oblReceived[0]['COUNT(container_id)']}` : "OBL Received: 0");
//         //   console.log(draftreceived.length > 0 ? `Draft Received: ${draftreceived[0]['COUNT(container_id)']}` : "Draft Received: 0");
//         //   console.log(receivedAndShared.length > 0 ? `Received And Shared: ${receivedAndShared[0]['COUNT(container_id)']}` : "Received And Shared: 0");

//         //   console.log(data16.length > 0 ? `Invoice Count: ${data16[0]['COUNT(invoice_id)']}` : "Invoice Count: 0");
//         //   console.log(data19.length > 0 ? `Deheading reportings : ${data19[0].Deheading}` : "Deheading reportings : 0");
//         //   console.log(data20.length > 0 ? `Grading Reportings: ${data20[0].Grading}` : "Grading Reportings: 0");
//         //   console.log(data22.length > 0 ? `Soaking Reportings: ${data22[0].Soaking}` : "Soaking Reportings: 0");
//         //   console.log(data21.length > 0 ? `value addition reportings: ${data21[0].Value}` : "value addition reportings: 0");
//         //   console.log(data23.length > 0 ? `NOn soaked product reportings: ${data23[0].Non}` : "NOn soaked product reportings: 0");
//         //   console.log(collectionData.length > 0 ? `Receivable: ${collectionData[0].counts}` : "Receivable: 0");
//         //   console.log(expensesData.length > 0 ? `Expenses: ${expensesData[0].counts}` : "Expenses: 0");
//         //   console.log(purchaseData.length > 0 ? `Purchases: ${purchaseData[0].counts}` : "Purchases: 0");



//           const response = {
//               "Enquiries": data17.length > 0 ? data17[0].Enq : 0,
//               "Costsheet": data18.length > 0 ? data18[0].Cost : 0,
//               "Sale Order": data.length > 0 ? data[0]['COUNT(sale_order_id)'] : 0,
//               "Purchase Order": data2.length > 0 ? data2[0]['COUNT(purchase_order_id)'] : 0,
//               "GRN": data3.length > 0 ? data3[0]['COUNT(grn_id)'] : 0,
//               "Stock": data4.length > 0 ? data4[0]['COUNT(stock_id)'] : 0,
//               "Material Requisition": data5.length > 0 ? data5[0]['COUNT(indent_material_preparation_id)'] : 0,
//               "Production Indent": data6.length > 0 ? data6[0]['COUNT(indent_form_id)'] : 0,
//               "Material Issues": data7.length > 0 ? data7[0]['COUNT(store_consumption_id)'] : 0,
//               "Indent Raised": data8.length > 0 ? data8[0]['COUNT(indent_id)'] : 0,
//               "Vehicle Assigned": data9.length > 0 ? data9[0]['COUNT(indent_id)'] : 0,
//               "RM GRN": data10.length > 0 ? data10[0]['COUNT(grn_id)'] : 0,
//               "STOCK IN": data11.length > 0 ? data11[0]['COUNT(stock_id)'] : 0,
//               "STOCK OUT": data12.length > 0 ? data12[0]['COUNT(job_id)'] : 0,
//               "Booked": data13.length > 0 ? data13[0]['COUNT(container_log_id)'] : 0,
//               "Loaded": data14.length > 0 ? data14[0]['COUNT(container_log_id)'] : 0,
//               "OBL Received": oblReceived.length > 0 ? oblReceived[0]['COUNT(container_id)']: 0 ,
//               "Draft Received": draftreceived.length > 0 ? draftreceived[0]['COUNT(container_id)']: 0 ,
//               "Received And Shared": receivedAndShared.length > 0 ? receivedAndShared[0]['COUNT(container_id)']: 0 ,
//               "SHIPPED": data15.length > 0 ? data15[0]['COUNT(container_log_id)'] : 0,
//               "Invoice": data16.length > 0 ? data16[0]['COUNT(invoice_id)'] : 0,
//               "Deheading Reportings": data19.length > 0 ? data19[0].Deheading : 0,
//               "Grading Reportings": data20.length > 0 ? data20[0].Grading : 0,
//               "Soaking Reportings": data22.length > 0 ? data22[0].Soaking : 0,
//               "Value Addition Reportings": data21.length > 0 ? data21[0].Value : 0,
//               "Non-soaked Product Reportings": data23.length > 0 ? data23[0].Non : 0,
//               "Receivable": collectionData.length > 0 ? collectionData[0].counts : 0,
//               "Expenses": expensesData.length > 0 ? expensesData[0].counts : 0,
//               "Purchases": purchaseData.length > 0 ? purchaseData[0].counts : 0
//           };

          

//           if (response) {
//             return new CommonResponse(true, 11108, "Data retrived sucessfully",response)
          
//         } else {
//             return new CommonResponse(false, 1, "some thing went wrong",[])
//         }
//     } catch (err) {
//         throw (err)
//     }

// }

async getDailySheetData1(req: DailySheetData): Promise<CommonResponse> {
    try {
        const manager = getManager();

        if (!req.fromDate || !req.toDate) {
            return new CommonResponse(false, 1, "Invalid date range provided");
        }

        // Generate all dates in the range (YYYY-MM-DD)
        const dateRange: string[] = [];
        let currentDate = new Date(req.fromDate);
        const endDate = new Date(req.toDate);

        while (currentDate <= endDate) {
            dateRange.push(currentDate.toISOString().split("T")[0]); // Keep consistent format
            currentDate.setDate(currentDate.getDate() + 1);
        }

        //               "OBL Received": oblReceived.length > 0 ? oblReceived[0]['COUNT(container_id)']: 0 ,
//               "Draft Received": draftreceived.length > 0 ? draftreceived[0]['COUNT(container_id)']: 0 ,
//               "Received And Shared": receivedAndShared.length > 0 ? receivedAndShared[0]['COUNT(container_id)']: 0 ,

  //          oblReceivedQuery=`SELECT COUNT(container_id),CAST(updated_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container WHERE bl_status="OBL RECEIVED" AND  DATE(updated_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}" `
//          draftReceivedQuery=`SELECT COUNT(container_id),CAST(updated_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container WHERE bl_status="DRAFT RECEIVED" AND DATE(updated_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}" `
//          receivedAndSharedQuery=`SELECT COUNT(container_id),CAST(updated_at AS DATE) FROM ` + appSettings.logistics_db+ ` .container WHERE bl_status="RECEIVED AND SHARED" AND DATE(updated_at) BETWEEN "${req.fromDate}" AND  "${req.toDate}" `

        
            const operations = [
  'PACKING',
  'DEGUMMING',
  'OPENING',
  'CARDING',
  'DRAWING',
  'COMBING',
  'PASSAGE',
  'DRESSING',
  'PICKING',
  'SPREADER',
  'SIMPLEX',
  'RING FRAME',
  'DOUBLING',
  'AUTO CONER',
  'GASING',
  'CONEWINDING',
  'REELING',
  'BLOWROOM',
  'FLAT CARDING',
  'OPEN END',
  'SET FRAME',
  'CARDING_C1/3'
];

        // Define all queries
        const queries = [
            // { name: "Enquiries", query: `SELECT COUNT(*) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.enquiry_db}.enquiries WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            // { name: "Costsheet", query: `SELECT COUNT(DISTINCT enquiry_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.enquiry_db}.cost_sheet WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            { name: "Sale Order", query: `SELECT COUNT(sale_order_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.sales_db}.sale_order WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            // { name: "Material Requisition", query: `SELECT COUNT(indent_material_preparation_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.procure_db}.indent_material_preparation WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            // { name: "Production Indent", query: `SELECT COUNT(indent_form_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.procure_db}.packing_indent WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            // { name: "Material Issues", query: `SELECT COUNT(store_consumption_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.procure_db}.store_consumption WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            { name: "RM Inward", query: `SELECT COUNT(indent_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.rm_procure_db}.indent WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            // { name: "Vehicle Assigned", query: `SELECT COUNT(indent_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.rm_procure_db}.indent WHERE vehicle_assigned = 1 AND DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            { name: "Price Allocation", query: `SELECT COUNT(grn_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.rm_procure_db}.grn WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            { name: "Export Bales", query: `SELECT COUNT(*) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.rm_procure_db}.bale_info WHERE type="Export" AND DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] }, // new added
            { name: "Production Bales", query: `SELECT COUNT(*) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.rm_procure_db}.bale_info WHERE type="Production" AND DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] }, // new added
            { name: "Reweighment", query: `SELECT COUNT(*) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.rm_procure_db}.act_bale_qty_logs WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] }, // new added

            { name: "Work Orders", query: `SELECT COUNT(*) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.rm_procure_db}.work_order_info WHERE work_order_no != 'W-DUMMY' AND DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] }, // new added
            
            { name: "Production Lots", query: `SELECT COUNT(*) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.production_db}.lot_info WHERE lot_type IN ('Dressing','Carding','Blowing') AND DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] }, // new added
            { name: "Clubbed Lots", query: `SELECT COUNT(*) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.production_db}.master_clubbed_lots WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] }, // new added
            
            // { name: "Receivable", query: `SELECT COUNT(*) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.finance_db}.collections WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            
            { name: "QAQC Silk Fibre Analysis", query: `SELECT COUNT(*) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.rm_procure_db}.qaqc_fibre_analysis WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] }, // new added
            { name: "QAQC Silk Fibre Lab Analysis", query: `SELECT COUNT(*) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.rm_procure_db}.qaqc_fibre_lab_analysis WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] }, // new added

            { name: "Purchase Order", query: `SELECT COUNT(purchase_order_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.procure_db}.purchase_order WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            { name: "GRN", query: `SELECT COUNT(grn_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.procure_db}.grn WHERE DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            { name: "Stock In (Production)", query: `SELECT COUNT(stock_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.warehouse_db}.stock WHERE stock_in_type="lot" AND DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            { name: "Stock In (Export)", query: `SELECT COUNT(stock_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.warehouse_db}.stock WHERE stock_in_type="workOrder" AND DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },

            { name: "Stock Out (Dispatch)", query: `SELECT COUNT(job_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.warehouse_db}.fork_lift_jobs WHERE job_purpose = 'dispatch' AND DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            { name: "Reprocessing", query: `SELECT COUNT(job_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.warehouse_db}.fork_lift_jobs WHERE job_purpose = 'reprocessing' AND DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            { name: "Repacking", query: `SELECT COUNT(job_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.warehouse_db}.fork_lift_jobs WHERE job_purpose = 'repacking' AND DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },
            
            { name: "Invoice", query: `SELECT COUNT(invoice_id) AS count, DATE_FORMAT(created_at, '%Y-%m-%d') AS date FROM ${appSettings.sales_db}.customer_invoice WHERE is_active =1 and DATE(created_at) BETWEEN ? AND ? GROUP BY DATE(created_at)`, params: [req.fromDate, req.toDate] },

             {
  name: "Receivable",
  query: `
    SELECT 
        SUM(count) AS count,
        date
    FROM (
        SELECT 
            COUNT(*) AS count, 
            DATE_FORMAT(created_at, '%Y-%m-%d') AS date
        FROM ${appSettings.finance_db}.collections
        WHERE DATE(created_at) BETWEEN ? AND ?
        GROUP BY DATE(created_at)

        UNION ALL

        SELECT 
            COUNT(*) AS count, 
            DATE_FORMAT(created_at, '%Y-%m-%d') AS date
        FROM ${appSettings.finance_db}.rodtep
        WHERE DATE(created_at) BETWEEN ? AND ?
        GROUP BY DATE(created_at)
    ) AS combined_counts
    GROUP BY date
  `,
  params: [req.fromDate, req.toDate, req.fromDate, req.toDate]
},
        ];

    
const operationQueries = operations.map(operation => ({
  name: operation,
  query: `
    SELECT
      COUNT(*) AS count,
      DATE_FORMAT(created_at, '%Y-%m-%d') AS date
    FROM ${appSettings.production_db}.production_log
    WHERE operation = ?
      AND DATE(created_at) BETWEEN ? AND ?
    GROUP BY DATE(created_at)
  `,
  params: [operation, req.fromDate, req.toDate]
}));

const productionLotsIndex = queries.findIndex(
  q => q.name === "Production Lots"
);

queries.splice(
  productionLotsIndex + 1,
  0,
  ...operationQueries
);



        // Execute all queries in parallel
        const results = await Promise.all(
            queries.map(q => manager.query(q.query, q.params))
        );
console.log("Results:", results);
        // Organize data into a structured format
        const responseData = queries.reduce((acc, q, index) => {
            const resultSet = results[index] || [];

            // Convert database results into a map
            const resultMap = resultSet.reduce((innerAcc, rec) => {
                innerAcc[rec.date] = Number(rec.count) || 0;
                return innerAcc;
            }, {} as Record<string, number>);

            // Ensure all dates in the range exist with default 0
            const operationData = dateRange.reduce((innerAcc, date) => {
                innerAcc[date] = resultMap[date] || 0;
                return innerAcc;
            }, {} as Record<string, number>);

            const totalCount = Object.values(operationData)
                .reduce((sum, val) => sum + val, 0);

            const isOperation = operations.includes(q.name);

            if (!isOperation || totalCount > 0) {
                acc[q.name] = operationData;
            }

            return acc;
        }, {} as Record<string, Record<string, number>>);
        console.log("Daily sheet data:", responseData);

        return new CommonResponse(true, 1, "Data retrived sucessfully", responseData);
    } catch (error) {
        console.error("Error fetching daily sheet data:", error);
        return new CommonResponse(false, 1, "Something went wrong", {});
    }
}  


 
    async getLoadingSheetPrintDetails(req: LoadingSheetSaleOrderReq): Promise<CommonResponse> {
        try {
            let query = ` SELECT c.container_id,c.container_number,c.line_seal,c.e_seal,DATE(c.loading_date) AS loadingDate,c.sale_order_id,
            c.stuffing_start_time,c.stuffing_completion_time,c.temp_indicator_no1,ls.variety,ls.lot_number,ci.invoice_number
             FROM ` + appSettings.logistics_db+ `.container c 
            LEFT JOIN ` + appSettings.logistics_db+ `.loading_sheet ls ON ls.sale_order_id=c.sale_order_id
            LEFT JOIN ` + appSettings.sales_db+ `.customer_invoice ci ON ci.sale_order_id=c.sale_order_id and ci.is_active =1
            WHERE c.sale_order_id='${req.saleOrderId}'
            GROUP BY c.sale_order_id
       ;`
            const data = await this.repository.query(query)

            if (data.length > 0) {
                return new CommonResponse(true, 0, "Loading Sheet nDetails retrieved successfully", data)
            } else {
                return new CommonResponse(false, 1, "No data found", [])
            }
        } catch (err) {
            throw (err)
        }

    }

    async getVarietyForLoadingSheet(req: LoadingSheetSaleOrderReq): Promise<CommonResponse> {
        try {
            let query = ` SELECT soi.sale_order_id,soi.varient_id,sku.short_code,sku.variant_code,sku.sku_code_id FROM ` + appSettings.sales_db + `.sale_order_items soi
            LEFT JOIN ` + appSettings.masters_db+ `.sku_codes sku ON sku.sku_code_id=soi.varient_id
            
            WHERE soi.sale_order_id='${req.saleOrderId}'
       ;`
       
            const data = await this.repository.query(query)

            if (data.length > 0) {
                return new CommonResponse(true, 0, "Variety Dropdown retrieved successfully", data)
            } else {
                return new CommonResponse(false, 1, "No data found", [])
            }
        } catch (err) {
            throw (err)
        }

    }

    async  getLotNumbersForLoadingPrint(req: LoadingSheetSaleOrderReq): Promise<CommonResponse> {
        try {
            const manager = getManager();
           
            let query = `SELECT ls.loadingSheet_id,ls.sale_order_id,ls.variety,ls.lot_number AS lotNumber,ls.count,sku.variant_code,sku.short_code AS variety FROM ` + appSettings.logistics_db+ `.loading_sheet ls
            LEFT JOIN ` + appSettings.masters_db+ `.sku_codes sku ON sku.sku_code_id=ls.variety
            WHERE ls.sale_order_id='${req.saleOrderId}'`;
    
            const results = await manager.query(query);
            
            interface PriceInfoModel {
                lotNumber: string;
                count: string;
                variety: string;
            }
            
            let priceInfo: PriceInfoModel[] = [];
            let prevLotNumber: string;
            let prevCount: string;

            let countVal: string;
            let sameLOtNumber: string[] = [];
            let prevVAriety: string;
    
            if (results) {
                for (const priceRec of results) {
                    // if (prevCount === priceRec.count && priceRec.variety === prevVAriety) {
                    //     sameLOtNumber.push((prevLotNumber));
                    //     // countVal = Math.min(...sameLOtNumber) + '-' + priceRec.lotNumber;
                    //     priceInfo.splice(-1);
                   
                    // } else {
                    //     sameLOtNumber = [];
                    //     countVal = priceRec.count;
                      
                    // }
                    priceInfo.push({ lotNumber: priceRec.lotNumber, count: priceRec.count, variety: priceRec.variety });
                    prevLotNumber = priceRec.lotNumber;
                    prevCount = priceRec.count;
                    prevVAriety = priceRec.variety;
                }

                // console.log(priceInfo);
                
                if(priceInfo.length >0 ){
                const resultMap = new Map<string, { lotNumber: string; count: string }[]>();
                for (const result of priceInfo) {
                    const { lotNumber, count, variety } = result;
                    if (!resultMap.has(variety)) {
                        resultMap.set(variety, []);
                    }
                    resultMap.get(variety).push({ lotNumber, count });
                }
        
                const responseData = [];
                for (const [variety, data] of resultMap.entries()) {
                    responseData.push({ variety, data });
                }

                if (responseData.length > 0) {
                    return new CommonResponse(true, 1, 'Data retrieved successfully', responseData);
                } else {
                    return new CommonResponse(false, 0, 'No data found', []);
                }
            }
            else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
            }
    
        } catch (err) {
            throw (err);
        }
    }


    async getGrossMassOfContainerPrintData(req: LoadingSheetSaleOrderReq): Promise<GrossMassResponseModel> {
        try {
            let query = ` SELECT c.container_id AS containerId,c.container_number AS containerNumber,c.container_size AS containerSize,c.sale_order_id AS saleOrderId,emp.employee_id AS employeeId,c.authorised_by AS authorisedBy,
            emp.employee_name AS employeeName,emp.designation AS designationId,emp.emp_last_name as empLastName,de.designation,dpt.dept_name as departmentName
            FROM ` + appSettings.logistics_db+ `.container c
            LEFT JOIN ` + appSettings.masters_db + `.employee_details emp ON emp.employee_id=c.authorised_by
             LEFT JOIN `+ appSettings.hrms_db + `.designation de ON de.designation_id=emp.designation
            LEFT JOIN ` + appSettings.masters_db + `.departments dpt ON dpt.dept_id=emp.department_id


        WHERE  c.sale_order_id = '${req.saleOrderId}'
        GROUP BY c.sale_order_id
       ;`
            const data = await this.soLoadingSheetRepo.query(query)

            if (data.length > 0) {
                return new GrossMassResponseModel(true, 0, " Details retrieved successfully", data)
            } else {
                return new GrossMassResponseModel(false, 1, "No data found", [])
            }
        } catch (err) {
            throw (err)
        }

    }

    async getPostShippmentDetailsById(req:saleOrderIdRequest): Promise<CommonResponse> {
        try {
        const Response = await this.postShipmentDetailsRepo.findOne({
          where: { saleOrderId: req.saleOrderId }
        });
        if (Response) {
            return new CommonResponse(true, 10115, 'Expenses record updated successfully', Response);
        } else {
          throw new ErrorResponse(99998, 'No Records Found');
        }
    } catch (err) {
        return err;
      }
    }

    async createPostShipmentDetails(createDto: PostShipmentDetailsDto): Promise<CommonResponse> {
        try {
            const existingEntity = await this.postShipmentDetailsRepo.findOne({ 
                where: { saleOrderId: createDto.saleOrderId } 
            });
    
            let entity: PostShipmentDetailsEntity;
            let action: string;
    
            if (existingEntity) {
                entity = this.adapter.convertDtoToEntity(createDto);
                entity.postShipmentId = existingEntity.postShipmentId;
                action = "updated";
            } else {
                entity = this.adapter.convertDtoToEntity(createDto);
                action = "created";
            }
    
            let containerEntity = await this.repository.findOne({ 
                where: { saleOrderId: entity.saleOrderId } 
            });
    
            if (containerEntity) {
                containerEntity.postShipmentReceivedStatus = true;
                await this.repository.save(containerEntity);
            }
    
            const savedEntity = await this.postShipmentDetailsRepo.save(entity);
    
            const saveDto: PostShipmentDetailsDto = this.adapter.convertEntityToDto(savedEntity);
    
            return new CommonResponse(true, 1, `Data ${action} successfully`, saveDto);
        } catch (error) {
            console.error('Error in createPostShipmentDetails:', error);
            return new CommonResponse(false, 0, error.message || 'An error occurred');
        }
    }
    
    
    
    
      

    // async createPostShipmentDetails(createDto: PostShipmentDetailsDto): Promise<CommonResponse> {
    //     try {
    //       const entity: PostShipmentDetailsEntity = this.adapter.convertDtoToEntity(createDto);
    //       const count: PostShipmentDetailsEntity = await this.postShipmentDetailsRepo.save(entity);
    //       const saveDto: PostShipmentDetailsDto = this.adapter.convertEntityToDto(count);
    
    //       return new CommonResponse(true, 1, 'Data saved successfully', saveDto);
    //     } catch (error) {
    //       return new CommonResponse(false, 0, error)
    //     }
    //   }

    // async createPostShipmentDetails(createDto: PostShipmentDetailsDto): Promise<CommonResponse> {
    //     try {
    //       const entity: PostShipmentDetailsEntity = this.adapter.convertDtoToEntity(createDto);
    //       const count: PostShipmentDetailsEntity = await this.postShipmentDetailsRepo.save(entity);
    //       const saveDto: PostShipmentDetailsDto = this.adapter.convertEntityToDto(count);
    
    //       return new CommonResponse(true, 1, 'Data saved successfully', saveDto);
    //     } catch (error) {
    //       return new CommonResponse(false, 0, error)
    //     }
    //   }

      async createExpensesLogistics(createDto: ExpensesLogisticsDto): Promise<CommonResponse> {
        try {
          const entity: ExpensesLogisticsEntity = this.adapter.convertExpensesDtoToEntity(createDto);
          const count: ExpensesLogisticsEntity = await this.expensesLogisticsRepo.save(entity);
          const saveDto: ExpensesLogisticsDto = this.adapter.convertExpensesEntityToDto(count);
    
          return new CommonResponse(true, 1, 'Data saved successfully', saveDto);
        } catch (error) {
          return new CommonResponse(false, 0, error)
        }
      }


      
    async getExpensesDetailsOfLogistics(): Promise<CommonResponse> {
        try {
            let query = ` SELECT exp.expenses_logistics_id as expensesLogisticsId,exp.sale_order_id as saleOrderId,exp.cha_bill as chaBill,exp.ocean_frieght as oceanFrieght,exp.domestic_frieght as domesticFrieght,exp.sales_comission as salesComission,
            exp.anti_dumping_duty as antiDumpingDuty,exp.cvd,exp.clearing_forwarding as clearingForwarding,exp.ddp_transport as ddpTransport,exp.marine_insurance as marineInsurance,exp.amc,exp.duty_drawback as dutyDrawback,
            exp.rodtep_amount as rodtepAmount,exp.fda_due_date as fdaDueDate,exp.remarks,soi.po_number AS poNumber
            FROM `+ appSettings.logistics_db+`.expenses exp
            LEFT JOIN `+ appSettings.sales_db+`.so_invoice_details soi ON soi.sale_order_id=exp.sale_order_id
       ;`
            const data = await this.expensesLogisticsRepo.query(query)
            if (data.length > 0) {
                return new CommonResponse(true, 0, " Details retrieved successfully", data)
            } else {
                return new CommonResponse(false, 1, "No data found", [])
            }
        } catch (err) {
            throw (err)
        }

    }


    // async updateExpensesLogistics(expensesDto: ExpensesLogisticsDto): Promise<CommonResponse> {
    //     try {

    //         const expensesLogistics = await this.getExpensesById(expensesDto.expensesLogisticsId);
    //         console.log(expensesLogistics,"props update done 2")

    //       if (expensesLogistics) {
    //         console.log(expensesLogistics,"props update done inside if")

    //         await this.expensesLogisticsRepo.update({ expensesLogisticsId: expensesLogistics.expensesLogisticsId }, {
    //           ...expensesDto,
    //         });
    
    //         const updatedDto: ExpensesLogisticsDto = this.adapter.convertExpensesEntityToDto({
    //           ...expensesLogistics,
    //           ...expensesDto,
    //         });
    //         console.log(updatedDto,"props update done updated 16789007532579")

    //         return new CommonResponse(true, 10115, 'Expenses record updated successfully', updatedDto);
    //       } else {
    //         throw new ErrorResponse(99998, 'No Records Found');
    //       }
    //     } catch (err) {
    //       return err;
    //     }
    //   }

    async updateExpensesLogistics(expensesDto: ExpensesLogisticsDto): Promise<CommonResponse> {
        try {
            const expensesLogistics = await this.expensesLogisticsRepo.findOne(expensesDto.expensesLogisticsId);
    
            if (!expensesLogistics) {
                throw new ErrorResponse(99998, 'No Records Found');
            }
    
            // Handle suffix logic for fdaDueDate
            let updatedFdaDueDate = expensesDto.fdaDueDate.split(' R')[0];
            let suffix = '';
    
            // Find the maximum suffix in the existing records for this expensesLogisticsId
            const maxSuffixRecord = await this.expensesLogisticsUpdateRepo.findOne({
                where: { expensesLogisticsId: expensesDto.expensesLogisticsId },
                order: { fdaDueDate: 'DESC' }, // Order by fdaDueDate in descending order
            });
    
            if (maxSuffixRecord && maxSuffixRecord.fdaDueDate.includes(' R')) {
                const maxSuffix = parseInt(maxSuffixRecord.fdaDueDate.split(' R')[1]);
                suffix = ` R${maxSuffix + 1}`;
            } else {
                suffix = ' R1';
            }
    
            // Update main entity with the new fdaDueDate (with suffix)
            const newFdaDueDate = `${updatedFdaDueDate}${suffix}`;
            await this.expensesLogisticsRepo.update({ expensesLogisticsId: expensesDto.expensesLogisticsId }, {
                ...expensesDto,
                fdaDueDate: newFdaDueDate,
            });
    
            // Create log entry with the updated fdaDueDate including suffix
            const updateEntity = new ExpensesLogisticsUpdateEntity();
            updateEntity.expensesLogisticsId = expensesDto.expensesLogisticsId;
            updateEntity.fdaDueDate = newFdaDueDate;
            updateEntity.remarks = expensesDto.remarks;
            updateEntity.isActive = true;
            updateEntity.createdUser = expensesDto.updatedUser; // Assuming updatedUser holds the user info
            updateEntity.updatedUser = expensesDto.updatedUser;
    
            // Save the log entry to the expensesLogisticsUpdateRepo
            await this.expensesLogisticsUpdateRepo.save(updateEntity);
    
            return new CommonResponse(true, 10115, 'Expenses record updated successfully', expensesDto);
        } catch (err) {
            return err;
        }
    }
    
    
    
    
    
      async getExpensesById(expensesLogisticsId: number): Promise<ExpensesLogisticsEntity> {
        const response = await this.expensesLogisticsRepo.findOne({
          where: { expensesLogisticsId: expensesLogisticsId },
          relations: ['updates'],
        });
        if (response) {
          return response;
        } else {
          return null;
        }
      }
 

    


    async getPortOfDischargeById(req: saleOrderBLIdrequest): Promise<CommonResponse> {
        try {
          
            let query = `SELECT ci.port_of_discharge,ci.sale_order_id,d.destination_name as destinationName FROM `+ appSettings.sales_db+`.customer_invoice ci LEFT JOIN `+ appSettings.masters_db+`.destination d ON d.destination_id=ci.port_of_discharge  WHERE  ci.sale_order_id = '${req.saleOrderId}' and ci.is_active =1`
            const data = await this.repository.query(query)
            if (data) {
                return new CommonResponse(true, 1111, "Data retreived sucesssfuly", data)
            } else {
                return new CommonResponse(false, 1111, "Error occure")

            }

        } catch (err) {
            return err;
        }
    }

    async getExpensesDetailsById(req:saleOrderIdRequest): Promise<CommonResponse> {
        try {
        const Response = await this.expensesLogisticsRepo.findOne({
          where: { saleOrderId: req.saleOrderId }
        });
        if (Response) {
            return new CommonResponse(true, 10115, 'Expenses record updated successfully', Response);
        } else {
          throw new ErrorResponse(99998, 'No Records Found');
        }
    } catch (err) {
        return err;
      }
    }

    async getPostShipmentDetailsLc(req: SaleOrderIdRequestLc): Promise<CommonResponse> {
        try {
            const getShippmentDetails = await this.postShipmentDetailsRepo.findOne({ saleOrderId: req.saleOrderId });
            if (getShippmentDetails != undefined) {
                const data = new PostShipmentCreateDto(getShippmentDetails.postShipmentId, getShippmentDetails.vesselNo, getShippmentDetails.vesselName, getShippmentDetails.marksNo, getShippmentDetails.dateOfIssue, getShippmentDetails.lcNo, getShippmentDetails.lcName, getShippmentDetails.lcBankAddress, getShippmentDetails.lcAmount,getShippmentDetails.saleOrderId);
                return new CommonResponse(true, 1001, "Shippment Details retrived successfully. ", data);
            }
            else {
                return new CommonResponse(false, 1010, "No data found. ");
            }
        }
        catch (err) {
            return err;
        }
    }

    async getVesselDetailsForPostShipment(req?: SaleOrderIdRequestLc):Promise<CommonResponse>{
        let query=`SELECT c.vc_no as vesselNo,c.vessel_name as vesselName,c.sale_order_id,c.container_id,ci.invoice_number as invoiceNumber,si.po_number as poNumber FROM ${appSettings.logistics_db}.container c
        LEFT JOIN ${appSettings.sales_db}.customer_invoice ci ON ci.sale_order_id = c.sale_order_id and ci.is_active =1
        LEFT JOIN ${appSettings.sales_db}.so_invoice_details si ON si.sale_order_id = c.sale_order_id 
        WHERE c.sale_order_id=${req.saleOrderId}`
        const data =await this.repository.query(query)
        if(data){
            return new CommonResponse(true,1,"Data Retreived Successfully",data)
        }else{
            return new CommonResponse(false,0,"no data found",[])

        }
    }
    async updateAuthorised(req:AuthorisedRequest):Promise<CommonResponse>{
        const manager = new GenericTransactionManager();
        try{
          await manager.startTransaction();
          const exist = await manager.getRepository(Container).findOne({ saleOrderId: req.saleOrderId })
          console.log(exist,'oooooo');
          
          if(exist){
            console.log('innnnnnnn');
            
            const update = await manager.getRepository(Container).update({saleOrderId:req.saleOrderId},{authorisedBy:req.authorisedId})
            console.log(update,'updateeeeeeeee');
            
            if(update.affected){
                await manager.completeTransaction()
                return new CommonResponse(true,1,"Authorised by updated Successfully")

            }else{
                await manager.releaseTransaction()
                return new CommonResponse(false,1," something went wrong in Authorised by updatedation")

            }
          }
          else{
            await manager.releaseTransaction()
            return new CommonResponse(false,1,"something went wrong in Authorised by updatedation")

          }
        }catch(err){
        console.log(err,'errrrrrrr');
          throw err
        }
      }

      async getCvdRatesForCustomsInvoice(req:componentRequest):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query =`SELECT gpl.effective_from,gpl.old_price as price,gpl.created_at,gpl.global_price_chart_id,gp.component
            FROM ${appSettings.masters_db}.global_price_chart_log gpl
            LEFT JOIN ${appSettings.masters_db}.global_price_chart gp ON gp.id=gpl.global_price_chart_id
            WHERE gp.component='${req.component}'`    
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                const mainQuery = `
      SELECT gp.component, gp.price, gp.created_at
      FROM ${appSettings.masters_db}.global_price_chart gp
      WHERE gp.component = '${req.component}'`;

    const mainResult = await manager.query(mainQuery);

    if (mainResult.length > 0) {
      return new CommonResponse(true, 1, 'Data retrieved from main table', mainResult);
    }else{
      return new CommonResponse(false, 0, `Data not found for ${req.component}`, mainResult);
    }
                // return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
    
        }
        }

        async getContainerStatusCount(req?:UnitRequest):Promise<CommonResponse>{
            console.log("Request received:", req);
            try{
                const manager = getManager()
                let query =`SELECT 
    st.container_status AS containerStatus,
    COUNT(*) AS containerStatusCount
FROM ${appSettings.sales_db}.sale_order so
LEFT JOIN ${appSettings.sales_db}.so_invoice_details soi ON soi.sale_order_id = so.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_track st ON st.sale_order_id = so.sale_order_id
LEFT JOIN ${appSettings.sales_db}.customer_invoice ci ON ci.sale_order_id=so.sale_order_id AND ci.is_active =1
WHERE st.container_status IS NOT NULL AND soi.job_type!='${JobTypesEnum.SUB_JOB}' and so.status != '${SaleOrderStatusEnum.CANCELLED}' and st.fg_status = '${FgStatusEnum.CLOSE}'
`    
if(req.unitId){
            query += ` and soi.processing_unit = ${req.unitId}`}
            if (req.financialYear != undefined && req.financialYear!=null) {
                query += ` and ci.financial_year = '${req. financialYear}'`;
            }
      if (req.fromDate != undefined) {
        query +=  ' and soi.act_edl_date between "' + req.fromDate + '" and "' + req.toDate + '"';
              }

if(req.companyId){
    query += ` and soi.factoryId = ${req.companyId}`}
    if(req.destinationId){
        query += ` and soi.destination = ${req.destinationId}`}
        query += ` GROUP BY st.container_status`
                const result = await manager.query(query)
                if(result.length > 0){
                    return new CommonResponse(true, 1,'Data retrieved successfully', result)
                }else{
                    return new CommonResponse(false, 0,'No data found',[])
                }
            }
        catch(err){
            console.log("Error occurred:", err);
            throw(err)
        }
    }

    async getSpsaPackingPrint(req: SaleOrderIdRequest): Promise<CommonResponse> {
        const manager=getManager()
        try {
            let query=`SELECT flj.job_id,flj.job_code,flj.date,flj.status,flj.job_purpose,flj.tot_issued_quantity AS netWeight,
            fli.sale_order_id,fli.sale_order_item_id,fli.stock_id,fli.pack_list_no,fli.sequence,fli.variant_id,
            soi.tare_weight,soi.product_description,sid.po_number AS poNumber,sid.invoice_date AS poDate,
            ci.invoice_number AS invoiceNo,ci.invoice_date AS invoiceDate,ci.exporter_id AS exportedId,ci.marks_and_no AS marksAndNo,
            fli.unit_id AS unitId,soi.package_type as packageType,soi.reported_cases as cases
            FROM ${appSettings.warehouse_db}.fork_lift_jobs flj
            LEFT JOIN ${appSettings.warehouse_db}.fork_lift_items fli ON fli.fork_lift_job_id=flj.job_id
            LEFT JOIN ${appSettings.sales_db}.so_invoice_details sid ON sid.sale_order_id=fli.sale_order_id
            LEFT JOIN ${appSettings.sales_db}.customer_invoice ci ON ci.sale_order_id=fli.sale_order_id
            LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_item_id=fli.sale_order_item_id
            WHERE flj.job_purpose='dispatch'`
            if(req.saleOrderId){
                query += ` and fli.sale_order_id=${req.saleOrderId}`
            }
            query +=` ORDER BY fli.sale_order_item_id,fli.sequence,fli.pack_list_no`
            const result = await manager.query(query)
            if(result.length === 0){
    return new CommonResponse(false,0,'No data found',[]);
}
            const firstRecord = result[0];

const header = {
    exporterId:firstRecord.exportedId,
    invoiceNo:firstRecord.invoiceNo,
    invoiceDate:firstRecord.invoiceDate,
    marksAndNo:firstRecord.marksAndNo,
    salesContract:firstRecord.poNumber,
    unitId:firstRecord.unitId,
    salesContractDate:firstRecord.poDate
};
const grouped = {};

for(const row of result){

    const key =
      `${row.sale_order_item_id}_${row.sequence}`;

    if(!grouped[key]){
        grouped[key]=[];
    }

    grouped[key].push(row);
}
function chunkArray(arr,size){

    const chunks=[];

    for(let i=0;i<arr.length;i+=size){

        chunks.push(
            arr.slice(i,i+size)
        );

    }

    return chunks;
}
const pages=[];
let pageNo=1;
Object.keys(grouped).forEach(key=>{

    const rows = grouped[key];

    const chunks =
      chunkArray(rows,40);

    chunks.forEach(chunk=>{

        const first=chunk[0];

        const totalNetWeight =
            chunk.reduce(
                (a,b)=>a+Number(b.netWeight||0),
                0
            );

        const totalGrossWeight =
            chunk.reduce(
                (a,b)=>
                a+
                Number(b.netWeight||0)+
                Number(b.tare_weight||0),
                0
            );

        pages.push({

            pageNo:pageNo++,

            saleOrderItemId:
                first.sale_order_item_id,

            sequence:
                first.sequence,

            productDescription:
                first.product_description,

            rows:chunk,

            totalBales:
                chunk.length,

            totalNetWeight,

            totalGrossWeight,
            packageType:first.packageType,
            soCases:first.cases

        });

    });

});
const saleOrderItemPageCount = {};

pages.forEach(page=>{

    saleOrderItemPageCount[
        page.saleOrderItemId
    ] =
        (saleOrderItemPageCount[
            page.saleOrderItemId
        ] || 0) + 1;

});
const packingAbstract=[];

const abstractRows = [];

const saleOrderItemCount = {};
pages.forEach(page=>{

    const firstRow = page.rows[0];
    const lastRow =
        page.rows[page.rows.length - 1];

    let baleRange='';

    if(
        firstRow.sequence === lastRow.sequence &&
        firstRow.pack_list_no === lastRow.pack_list_no
    ){

        baleRange =
          `${firstRow.sequence}${firstRow.pack_list_no}`;

    }else{

        baleRange =
          `${firstRow.sequence}${firstRow.pack_list_no}-${lastRow.sequence}${lastRow.pack_list_no}`;

    }

    packingAbstract.push({

        saleOrderItemId:
            page.saleOrderItemId,

        productDescription:
            page.productDescription,

        rowspan:
            saleOrderItemPageCount[
                page.saleOrderItemId
            ],

        baleRange,

        totalBales:
            page.totalBales,

        totalGrossWeight:
            page.totalGrossWeight,

        totalNetWeight:
            page.totalNetWeight

    });

});

const abstractTotalBales =
    packingAbstract.reduce(
        (sum,item)=>
            sum + item.totalBales,
        0
    );

const abstractTotalGrossWeight =
    packingAbstract.reduce(
        (sum,item)=>
            sum + item.totalGrossWeight,
        0
    );

const abstractTotalNetWeight =
    packingAbstract.reduce(
        (sum,item)=>
            sum + item.totalNetWeight,
        0
    );

            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', {
        
        header,
        pages,
        packingAbstract,

        abstractTotals:{
            totalBales:
                abstractTotalBales,

            totalGrossWeight:
                abstractTotalGrossWeight,

            totalNetWeight:
                abstractTotalNetWeight
        }
    })
            }
            else{
                return new CommonResponse(false, 0,'No data found',[])
            }
                    }catch(err){
                        throw(err)
                    }
                }
    
}



